(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["account"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-account]');
    if (!root) return;

    /* ---------- customer name (skeleton → real, cached for instant return visits) ---------- */
    function setAccountName(name, noCache) {
      var span = root.querySelector('[data-acc-name]');
      if (!span || !name) return;
      span.textContent = name;
      span.classList.remove('account__title-name--loading');
      if (!noCache) { try { localStorage.setItem('caa_name', name); } catch (e) {} }
    }
    // instant-paint cached name on return visits — real mode only, so demo's mock name never
    // leaks into (or out of) the cache and ?demo=loading keeps its skeleton
    if (!/[?&]demo/.test(location.search)) {
      try { var cachedName = localStorage.getItem('caa_name'); if (cachedName) setAccountName(cachedName); } catch (e) {}
    }

    /* ---------- toast ---------- */
    var toast = document.querySelector('[data-toast]');
    var toastTimer;
    function showToast(msg) {
      if (!toast) return;
      toast.textContent = msg;
      toast.classList.add('is-visible');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toast.classList.remove('is-visible'); }, 3000);
    }

    /* ---------- cut-line effect ---------- */
    function lineCut(el, after) {
      el.classList.remove('is-cutting');
      void el.offsetWidth;
      el.classList.add('is-cutting');
      setTimeout(function () {
        el.classList.remove('is-cutting');
        if (typeof after === 'function') after();
      }, 320);
    }
    root.querySelectorAll('.account__cutlink').forEach(function (el) {
      el.addEventListener('click', function () { lineCut(el); });
    });

    /* ---------- tabs ---------- */
    var navLinks = root.querySelectorAll('[data-tab-target]');
    function switchTab(tabId) {
      root.querySelectorAll('.account__panel').forEach(function (p) { p.classList.remove('is-active'); });
      var target = document.getElementById(tabId);
      if (target) setTimeout(function () { target.classList.add('is-active'); }, 50);
      navLinks.forEach(function (l) {
        l.classList.toggle('is-active', l.getAttribute('data-tab-target') === tabId);
      });
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    navLinks.forEach(function (l) {
      l.addEventListener('click', function () { switchTab(l.getAttribute('data-tab-target')); });
    });

    /* ---------- overview bundle stack (FLIP) ---------- */
    function bindOvStack(stack) {
      stack.querySelectorAll('[data-ov-bthumb]').forEach(function (t) {
        t.addEventListener('click', function () { selectOvThumb(stack, t); });
      });
    }
    function selectOvThumb(stack, thumb) {
      if (stack.firstElementChild === thumb) return;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var before = new Map();
      Array.prototype.forEach.call(stack.children, function (t) { before.set(t, t.getBoundingClientRect()); });
      stack.prepend(thumb);
      if (reduce || !thumb.animate) return;
      Array.prototype.forEach.call(stack.children, function (item) {
        var from = before.get(item);
        if (!from) return;
        var to = item.getBoundingClientRect();
        var dx = from.left - to.left, dy = from.top - to.top;
        if (!dx && !dy) return;
        item.animate(
          [{ transform: 'translate(' + dx + 'px, ' + dy + 'px)' }, { transform: 'translate(0, 0)' }],
          { duration: 260, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
        );
      });
    }
    var ovStack = root.querySelector('[data-ov-stack]');
    if (ovStack) bindOvStack(ovStack);

    /* ---------- waitlist secure button sequence ---------- */
    function secureSequence(btn, after) {
      if (btn.classList.contains('is-securing') || btn.classList.contains('is-allocated')) return;
      btn.classList.add('is-securing');
      btn.disabled = true;
      setTimeout(function () {
        btn.classList.remove('is-securing');
        btn.classList.add('is-allocated');
        setTimeout(function () {
          btn.classList.remove('is-allocated');
          btn.disabled = false;
          if (typeof after === 'function') after();
        }, 600);
      }, 1000);
    }

    /* ---------- waitlist filter + demo actions ---------- */
    root.querySelectorAll('[data-wl-filter]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('[data-wl-filter]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        var status = btn.getAttribute('data-wl-filter');
        root.querySelectorAll('.account__wl-card').forEach(function (card) {
          card.hidden = status !== 'all' && card.getAttribute('data-waitlist-status') !== status;
        });
      });
    });
    root.querySelectorAll('[data-wl-secure]').forEach(function (btn) {
      btn.addEventListener('click', function () { secureSequence(btn, function () { showToast('Allocation secured in demo mode.'); }); });
    });
    root.querySelectorAll('[data-wl-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () { showToast('Interest removed in demo mode.'); });
    });
    // Reorder puts the ordered variants back in the bag. The drawer owns the write and opens
    // itself on success, so this only hands over the ids and reports a refusal (sold out, gone).
    // The demo cards carry no ids — they keep the placeholder toast.
    function reorder(btn) {
      var ids = (btn.getAttribute('data-reorder') || '').split(',').filter(Boolean);
      if (!ids.length) { showToast('Opening the product page...'); return; }
      var pending = ids.length;
      var failed = 0;
      function settle(e) {
        if (e.detail && !e.detail.ok) failed++;
        if (--pending > 0) return;
        document.removeEventListener('arforti:cart-added', settle);
        if (failed === ids.length) showToast((e.detail && e.detail.message) || 'This piece is no longer available.');
      }
      document.addEventListener('arforti:cart-added', settle);
      ids.forEach(function (id) {
        document.dispatchEvent(new CustomEvent('arforti:cart-add', { detail: { id: id } }));
      });
    }
    root.querySelectorAll('[data-reorder]').forEach(function (btn) {
      btn.addEventListener('click', function () { reorder(btn); });
    });
    var logoutBtn = root.querySelector('[data-logout]');

    /* ---------- addresses (demo shell) ---------- */
    var addrList = root.querySelector('[data-addr-list]');
    var addrForm = root.querySelector('[data-addr-form]');
    var addrFormTitle = root.querySelector('[data-addr-form-title]');
    var editingAddr = null;
    function fillAddrForm(a) {
      document.getElementById('acc-lname').value = (a && a.lastName) || '';
      document.getElementById('acc-fname').value = (a && a.firstName) || '';
      document.getElementById('acc-phone').value = (a && a.phoneNumber) || '';
      document.getElementById('acc-street').value = (a && a.address1) || '';
      document.getElementById('acc-city').value = (a && a.city) || '';
      document.getElementById('acc-zip').value = (a && a.zip) || '';
    }
    function openAddrForm(isEdit, a) {
      switchTab('tab-addresses');
      addrList.hidden = true;
      addrForm.hidden = false;
      addrFormTitle.textContent = isEdit ? 'Edit Address' : 'Add New Address';
      editingAddr = isEdit ? (a || addrData) : null;
      if (isEdit) fillAddrForm(editingAddr);
      else root.querySelector('[data-address-form]').reset();
    }
    function closeAddrForm() {
      addrList.hidden = false;
      addrForm.hidden = true;
    }
    root.querySelectorAll('[data-open-addr-form]').forEach(function (el) {
      el.addEventListener('click', function (e) { e.stopPropagation(); openAddrForm(true); });
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openAddrForm(true); }
      });
    });
    var addNewBtn = root.querySelector('[data-open-addr-form-new]');
    if (addNewBtn) addNewBtn.addEventListener('click', function () { openAddrForm(false); });
    root.querySelectorAll('[data-close-addr-form]').forEach(function (el) {
      el.addEventListener('click', closeAddrForm);
    });
    var gotoAddr = root.querySelector('[data-goto-addresses]');
    if (gotoAddr) {
      // On mobile the whole overview address card opens the edit form directly (no separate Edit tap);
      // on desktop it goes to the Addresses tab where the Edit button lives.
      var gotoAddrAction = function () {
        if (window.matchMedia('(max-width: 1023px)').matches) openAddrForm(true);
        else switchTab('tab-addresses');
      };
      gotoAddr.addEventListener('click', gotoAddrAction);
      gotoAddr.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); gotoAddrAction(); }
      });
    }
    var addrFormEl = root.querySelector('[data-address-form]');
    if (addrFormEl) addrFormEl.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!addrFormEl.checkValidity()) { addrFormEl.reportValidity(); return; }
      showToast('Address details saved to your profile.');
      closeAddrForm();
    });

    /* ---------- crafting progress engine ---------- */
    var isFulfilled = false;
    // real carrier off the order's fulfillment; falls back to the section setting when the
    // order has no tracking company yet (unfulfilled, or a carrier the shop didn't name)
    var liveCarrier = null;
    var allTracking = [];
    var demoTracking = null;
    var isPartial = false;
    var restItems = [];
    /* Day ranges are structural — they decide which of the six steps a piece is in — so they stay
       here. Every word comes from the section settings, shared with the modal's timeline. */
    var CFG = window.__ARFORTI_ACC__ || {};
    var STEP_COPY = CFG.steps || [];
    var STEP_BADGES = CFG.badges || [];
    var PHASES = [
      { from: 1, to: 2, steps: 1 },
      { from: 3, to: 5, steps: 2 },
      { from: 6, to: 9, steps: 3 },
      { from: 10, to: 13, steps: 4 },
      { from: 14, to: 15, steps: 5 }
    ].map(function (p) {
      var s = STEP_COPY[p.steps - 1] || {};
      return { from: p.from, to: p.to, steps: p.steps, title: s.title, desc: s.desc, badge: STEP_BADGES[p.steps - 1] };
    });
    // the tracking row only exists when the carrier gave us a url — no url, no row
    // one row per tracking number: a split order ships in several parcels, and the policy
    // says so out loud, so every parcel gets its own line rather than only the first
    function paintTrackLink() {
      var list = document.querySelector('[data-track-list]');
      if (!list) return;
      list.textContent = '';
      list.hidden = false;
      // one box needs no label; two or more do, or the client cannot tell them apart
      var needsRest = !allTracking.length || isPartial;
      var labelled = allTracking.length + (needsRest ? 1 : 0) > 1;
      var addLabel = function (text, items) {
        if (!labelled) return;
        var lb = document.createElement('span');
        lb.className = 'account-track__ship-label ts-sm-xs';
        lb.textContent = (items && items.length) ? text + ' : ' + items.join(', ') : text;
        list.appendChild(lb);
      };
      allTracking.forEach(function (t, i) {
        addLabel('Package ' + (i + 1), t.items);
        var label = [t.company, t.number].filter(Boolean).join(' · ');
        var el;
        if (t.url) {
          el = document.createElement('a');
          el.className = 'account-track__ship ts-sm';
          el.href = t.url;
          el.target = '_blank';
          el.rel = 'noopener';
          el.textContent = label || 'Track Shipment';
        } else {
          // no url — plain text that copies on click; no cut-line, it is not a link
          el = document.createElement('button');
          el.type = 'button';
          el.className = 'account-track__ship account-track__ship--copy ts-sm';
          el.textContent = label;
          el.addEventListener('click', function () {
            if (!t.number || !navigator.clipboard) return;
            navigator.clipboard.writeText(t.number).then(function () { showToast('Tracking number copied.'); });
          });
        }
        list.appendChild(el);
      });

      // nothing shipped, or only part of the order shipped: say where the rest of it is
      if (needsRest) {
        addLabel('In the Atelier', restItems);
        var badgeEl = root.querySelector('[data-status-badge]');
        var st = document.createElement('div');
        st.className = 'account-track__ship account-track__ship--status ts-sm';
        st.textContent = badgeEl ? badgeEl.textContent.trim() : '';
        list.appendChild(st);
      }
    }

    function updateProgress(day) {
      var fill = root.querySelector('[data-progress-fill]');
      var dot = root.querySelector('[data-progress-dot]');
      var titleEl = root.querySelector('[data-phase-title]');
      var labelEl = root.querySelector('[data-day-label]');
      var descEl = root.querySelector('[data-phase-desc]');
      var badgeEl = root.querySelector('[data-status-badge]');
      var archiveDot = root.querySelector('[data-archive-dot]');
      var archiveStatus = root.querySelector('[data-archive-status]');

      var pct = Math.min(100, Math.max(0, ((day - 1) / 15) * 100));
      if (fill) fill.style.width = pct + '%';
      if (dot) dot.style.left = pct + '%';

      var title, desc, badge, steps = 0, s6t, s6d;
      var phase = null;
      for (var i = 0; PHASES.length > i; i++) {
        if (day >= PHASES[i].from && PHASES[i].to >= day) { phase = PHASES[i]; break; }
      }
      if (phase) {
        title = phase.title; desc = phase.desc; badge = phase.badge; steps = phase.steps;
      } else if (day >= 16) {
        steps = 6;
        var last = STEP_COPY[5] || {};
        var ship = CFG.shipped || {};
        if (!isFulfilled) {
          title = last.title;
          desc = last.desc;
          badge = CFG.restingBadge;
          s6t = last.title;
          s6d = last.desc;
          if (labelEl) labelEl.textContent = CFG.restingLabel;
        } else {
          title = ship.status;
          desc = ship.desc;
          badge = ship.badge;
          s6t = ship.title;
          s6d = ship.desc;
          if (labelEl) labelEl.textContent = liveCarrier || ship.carrier;
        }
      }

      if (day <= 15 && labelEl) labelEl.textContent = 'Day ' + day + ' of 15';
      if (titleEl && title) titleEl.textContent = title;
      if (descEl && desc) descEl.textContent = desc;
      if (badgeEl && badge) badgeEl.textContent = badge;
      if (archiveStatus && title) archiveStatus.textContent = title;
      if (archiveDot) archiveDot.classList.toggle('is-pulsing', !(day >= 16 && isFulfilled));

      for (var n = 1; n <= 6; n++) {
        var step = document.querySelector('[data-track-step="' + n + '"]');
        if (!step) continue;
        step.classList.toggle('is-active', steps >= n);
        step.classList.toggle('is-reached', n < steps);
        step.classList.toggle('is-current', n === steps);
      }
      var t6 = document.querySelector('[data-step-title="6"]');
      var d6 = document.querySelector('[data-step-desc="6"]');
      var dt6 = document.querySelector('[data-step-date="6"]');
      var step6 = STEP_COPY[5] || {};
      var shipCfg = CFG.shipped || {};
      if (day >= 16 && isFulfilled) {
        if (t6) t6.textContent = s6t;
        if (d6) d6.textContent = s6d;
        if (dt6) dt6.textContent = shipCfg.day;
      } else {
        if (t6) t6.textContent = step6.title;
        if (d6) d6.textContent = step6.desc;
        if (dt6) dt6.textContent = step6.day;
      }
      paintTrackLink();
    }
    updateProgress(10);

    /* ---------- modals ---------- */
    function openModal(m) {
      m.hidden = false;
      void m.offsetWidth;
      m.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function closeModal(m) {
      m.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(function () { m.hidden = true; }, 400);
    }
    var trackModal = document.querySelector('[data-tracking-modal]');
    function animateTrackSteps() {
      document.querySelectorAll('.account-track__step.is-ping').forEach(function (s) { s.classList.remove('is-ping'); });
      var steps = Array.prototype.slice.call(document.querySelectorAll('.account-track__step.is-active'));
      var current = document.querySelector('.account-track__step.is-current');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !steps.length || !document.body.animate) {
        if (current) current.classList.add('is-ping');
        return;
      }
      var cs = getComputedStyle(document.documentElement);
      var ink = (cs.getPropertyValue('--site-color-text') || '#2A2A2A').trim() || '#2A2A2A';
      var bg = (cs.getPropertyValue('--site-color-bg') || '#FDFDFD').trim() || '#FDFDFD';
      var line = (cs.getPropertyValue('--site-color-line') || '#D1D1CD').trim() || '#D1D1CD';
      var t = 320;
      steps.forEach(function (step, i) {
        var dot = step.querySelector('.account-track__dot');
        var copy = step.querySelector('.account-track__copy');
        var rail = step.querySelector('.account-track__line');
        var grow = rail && step.classList.contains('is-reached');
        if (dot) {
          dot.animate(
            [{ transform: 'scale(0.72)', backgroundColor: bg, borderColor: line }, { transform: 'scale(1)', backgroundColor: ink, borderColor: ink }],
            { duration: 220, delay: t, easing: 'cubic-bezier(0.33, 1, 0.68, 1)', fill: 'backwards' }
          );
        }
        if (copy) {
          copy.animate(
            [{ opacity: 0.34, transform: 'translateY(6px)' }, { opacity: 1, transform: 'translateY(0)' }],
            { duration: 280, delay: t + 30, easing: 'cubic-bezier(0.33, 1, 0.68, 1)', fill: 'backwards' }
          );
        }
        if (grow) {
          rail.animate(
            [{ transform: 'scaleY(0)' }, { transform: 'scaleY(1)' }],
            { duration: 520, delay: t + 200, easing: 'cubic-bezier(0.37, 0, 0.63, 1)', fill: 'backwards' }
          );
        }
        if (i === steps.length - 1 && current) {
          setTimeout(function () { current.classList.add('is-ping'); }, t + 260);
        }
        t += grow ? 700 : 240;
      });
    }
    function openTrack() {
      openModal(trackModal);
      animateTrackSteps();
    }
    document.querySelectorAll('[data-open-tracking]').forEach(function (b) {
      b.addEventListener('click', function () { lineCut(b, openTrack); });
    });
    document.querySelectorAll('[data-close-tracking]').forEach(function (b) {
      b.addEventListener('click', function () { closeModal(trackModal); });
    });
    var trackConcierge = document.querySelector('[data-track-concierge]');
    if (trackConcierge) trackConcierge.addEventListener('click', function () {
      lineCut(trackConcierge, function () {
        closeModal(trackModal);
        switchTab('tab-concierge');
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (trackModal && trackModal.classList.contains('is-open')) closeModal(trackModal);
    });


    /* ---------- data layer (Customer Account API) ---------- */
    var ACC = window.__ARFORTI_ACC__ || {};
    function money(amount, cur) {
      try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur || ACC.currency || 'USD', currencyDisplay: 'narrowSymbol', minimumFractionDigits: 0 }).format(parseFloat(amount)); }
      catch (e) { return '$' + amount; }
    }
    function fmtLong(d) { return new Date(d).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }); }
    function esc(x) { var d = document.createElement('div'); d.textContent = x == null ? '' : x; return d.innerHTML; }
    function dayOf(processedAt) { return Math.max(1, Math.floor((Date.now() - new Date(processedAt).getTime()) / 864e5) + 1); }

    function withCaa(fn) {
      if (window.ARFORTI_CAA) fn(window.ARFORTI_CAA);
      else document.addEventListener('caa:ready', function () { fn(window.ARFORTI_CAA); }, { once: true });
    }
    function gate(on) {
      root.classList.toggle('account--gated', on);
      if (on) root.classList.remove('account--loading'); // signin view replaces the layout; no skeletons behind it
    }

    var Q = 'query AccountData { customer { id firstName lastName emailAddress { emailAddress } defaultAddress { id firstName lastName phoneNumber address1 address2 city zip territoryCode } addresses(first: 10) { nodes { id firstName lastName phoneNumber address1 address2 city zip territoryCode } } metafield(namespace: "' + (ACC.wlNs || 'custom') + '", key: "' + (ACC.wlKey || 'waitlist') + '") { value } orders(first: 10, sortKey: PROCESSED_AT, reverse: true) { nodes { id name processedAt fulfillmentStatus fulfillments(first: 5) { nodes { latestShipmentStatus trackingInformation { company number url } fulfillmentLineItems(first: 10) { nodes { quantity lineItem { name } } } } } totalPrice { amount currencyCode } lineItems(first: 10) { nodes { name variantTitle presentmentTitle quantity productId variantId image { url } variantOptions { name value } customAttributes { key value } } } } } } }';

    function optPairs(li) {
      return (li.variantOptions || []).filter(function (o) {
        return o && o.value && o.value !== 'Default Title' && o.name !== 'Title';
      });
    }
    // The API's LineItem has no metafields, so the leather comes from the server-rendered map and
    // is joined on productId here. Silent when a product has no leather set — the line just drops.
    var LEATHER = (function () {
      var el = root.querySelector('[data-leather-map]');
      if (!el) return {};
      try { return JSON.parse(el.textContent) || {}; } catch (e) { return {}; }
    })();
    // Orders placed after the _Material property shipped carry the leather themselves, which
    // survives the product being renamed, unpublished or deleted. Everything ordered before that
    // falls back to the map. Order data wins: it is what the client actually bought.
    function leatherOf(li) {
      var attrs = (li && li.customAttributes) || [];
      for (var i = 0; attrs.length > i; i++) {
        if (attrs[i] && attrs[i].key === '_Material' && attrs[i].value) return attrs[i].value;
      }
      var pid = String((li && li.productId) || '').replace(/^.*\//, '');
      return pid && LEATHER[pid] ? LEATHER[pid] : '';
    }
    function metaLinesHtml(li) {
      var lines = optPairs(li).map(function (o) { return esc(o.name) + ': ' + esc(o.value); });
      if (!lines.length && li.presentmentTitle && li.presentmentTitle !== 'Default Title') lines.push(esc(li.presentmentTitle));
      // skipped when the leather is already one of the option values, so making Material a variant
      // option later can never print it twice — same guard the waitlist cards use
      var lth = leatherOf(li);
      if (lth && optPairs(li).map(function (o) { return o.value; }).indexOf(lth) === -1) {
        lines.push('Material: ' + esc(lth));
      }
      lines.push('Qty: ' + (li.quantity || 1));
      return lines.join('\x3Cbr>');
    }
    function productTitle(li) {
      var n = li.name || 'Commission';
      var vt = li.variantTitle;
      if (vt && vt !== 'Default Title') {
        var suffix = ' - ' + vt;
        if (n.length > suffix.length && n.slice(-suffix.length) === suffix) n = n.slice(0, -suffix.length);
      }
      return n;
    }
    function thumbHtml(li) {
      if (li && li.image && li.image.url) return '\x3Cimg src="' + esc(li.image.url + (li.image.url.indexOf('?') > -1 ? '&' : '?') + 'width=300') + '" alt="' + esc(li.name) + '" style="width:100%;height:100%;object-fit:cover;">';
      return '\x3Cspan class="account__thumb-label ts-sm-xs">[ ARFORTI ]\x3C/span>';
    }

    function renderOverview(orders) {
      var ovCard = root.querySelector('[data-ov-order]');
      var ovEmpty = root.querySelector('[data-ov-empty]');
      var current = null;
      for (var i = 0; orders.length > i; i++) { if (orders[i].fulfillmentStatus !== 'FULFILLED') { current = orders[i]; break; } }
      if (!current && orders.length) current = orders[0];
      if (!current) { ovCard.hidden = true; ovEmpty.hidden = false; return; }
      var items = current.lineItems.nodes || [];
      var li = items[0] || {};
      ovCard.querySelector('.account__order-ref').textContent = 'Order ' + current.name;
      var tr = document.querySelector('[data-track-ref]');
      if (tr) tr.textContent = 'Order ' + current.name;
      var single = ovCard.querySelector('[data-ov-single]');
      var bundle = ovCard.querySelector('[data-ov-bundle]');
      if (items.length > 1) {
        if (bundle) bundle.hidden = false;
        if (single) single.hidden = true;
        var stack = ovCard.querySelector('[data-ov-stack]');
        if (stack) {
          stack.innerHTML = items.map(function (it) {
            return '\x3Cbutton type="button" class="account__ov-bthumb" data-ov-bthumb aria-label="Show ' + esc(it.name || 'piece') + ' first">' + thumbHtml(it) + '\x3C/button>';
          }).join('');
          bindOvStack(stack);
        }
        var titleEl = ovCard.querySelector('[data-ov-bundle-title]');
        var countEl = ovCard.querySelector('[data-ov-bundle-count]');
        // the piece itself, not a coined label: "bundle" reads as a discounted package deal,
        // and the count line right below already says how many pieces the order holds
        if (titleEl) titleEl.textContent = productTitle(li);
        if (countEl) countEl.textContent = 'Includes ' + items.length + ' atelier pieces';
      } else {
        if (bundle) bundle.hidden = true;
        if (single) single.hidden = false;
        var nameEl2 = ovCard.querySelector('[data-ov-single-name]');
        var metaEl = ovCard.querySelector('[data-ov-single-meta]');
        var thumbEl = ovCard.querySelector('[data-ov-single-thumb]');
        if (nameEl2) nameEl2.textContent = productTitle(li);
        if (metaEl) metaEl.innerHTML = metaLinesHtml(li);
        if (thumbEl) thumbEl.innerHTML = thumbHtml(li);
      }
      isFulfilled = current.fulfillmentStatus === 'FULFILLED';
      isPartial = current.fulfillmentStatus === 'PARTIALLY_FULFILLED';
      liveCarrier = null;
      allTracking = [];
      var ffNodes = (current.fulfillments && current.fulfillments.nodes) || [];
      var shippedNames = {};
      ffNodes.forEach(function (ff) {
        var names = ((ff.fulfillmentLineItems && ff.fulfillmentLineItems.nodes) || [])
          .map(function (fl) { return fl.lineItem && fl.lineItem.name; })
          .filter(Boolean);
        names.forEach(function (nm) { shippedNames[nm] = true; });
        (ff.trackingInformation || []).forEach(function (ti) {
          if (!ti || (!ti.url && !ti.number)) return;
          allTracking.push({ company: ti.company, number: ti.number, url: ti.url, items: names });
          if (ti.company && !liveCarrier) liveCarrier = ti.company;
        });
      });
      // whatever the order holds that no fulfillment claimed is still in the atelier
      restItems = (((current.lineItems || {}).nodes) || [])
        .map(function (li) { return li.name; })
        .filter(function (nm) { return nm && !shippedNames[nm]; });
      updateProgress(Math.min(16, dayOf(current.processedAt)));
    }

    function orderCardHtml(o) {
      var items = o.lineItems.nodes || [];
      var li = items[0] || {};
      var multi = items.length > 1;
      // Reorder needs the variants back, and the cart takes the bare numeric id, not the gid.
      var reorderIds = items.map(function (x) {
        return String((x && x.variantId) || '').replace(/^.*\//, '');
      }).filter(Boolean).join(',');
      var done = o.fulfillmentStatus === 'FULFILLED';
      var day = Math.min(16, dayOf(o.processedAt));
      var phase = null;
      for (var i = 0; PHASES.length > i; i++) { if (day >= PHASES[i].from && PHASES[i].to >= day) { phase = PHASES[i]; break; } }
      var statusLabel = done ? 'Delivered' : (phase ? phase.title : 'Resting & Packaging');
      var statusHtml = '\x3Cspan class="ts-h-xs">' + esc(statusLabel) + '\x3C/span>';
      var productHtml;
      if (multi) {
        productHtml = '\x3Cdiv class="account__bundle-row">\x3Cdiv class="account__bundle-gallery">\x3Cdiv class="account__bundle-track">' +
          items.map(function (it) {
            return '\x3Cdiv class="account__bundle-card">' +
              '\x3Cdiv class="account__bundle-thumb">' + thumbHtml(it) + '\x3C/div>' +
              '\x3Cdiv>\x3Ch4 class="account__order-name ts-h-l">' + esc(productTitle(it)) + '\x3C/h4>' +
              '\x3Cdiv class="account__bundle-meta ts-sm">' +
                // one span per value: .account__bundle-meta is a flex column, so colour and
                // leather each take their own line rather than running together on one
                (function () {
                  var parts = optPairs(it).map(function (o) { return esc(o.value); });
                  if (!parts.length && it.presentmentTitle && it.presentmentTitle !== 'Default Title') parts.push(esc(it.presentmentTitle));
                  var bl = leatherOf(it);
                  if (bl && parts.indexOf(esc(bl)) === -1) parts.push(esc(bl));
                  return parts.map(function (v) { return '\x3Cspan>' + v + '\x3C/span>'; }).join('');
                })() +
                '\x3Cspan>Qty: ' + (it.quantity || 1) + '\x3C/span>' +
              '\x3C/div>\x3C/div>\x3C/div>';
          }).join('') +
          '\x3C/div>\x3C/div>' +
          // beside the rail, on the images' midline — Track Progress while it is being made,
          // Reorder once it has arrived. A single-piece card keeps its own two placements.
          (done
            ? (reorderIds ? '\x3Cbutton type="button" class="account__cutlink account__order-action ts-sm" data-reorder="' + reorderIds + '">Reorder\x3C/button>' : '')
            : '\x3Cbutton type="button" class="account__order-btn account__order-action ts-sm" data-open-tracking>Track Progress\x3C/button>') +
          '\x3C/div>';
      } else {
        productHtml = '\x3Cdiv class="account__order-product">' +
          '\x3Cdiv class="account__thumb account__thumb--placeholder">' + thumbHtml(li) + '\x3C/div>' +
          '\x3Cdiv class="account__order-copy">\x3Ch4 class="account__order-name ts-h-l">' + esc(productTitle(li)) + '\x3C/h4>' +
          '\x3Cp class="account__order-variant ts-sm">' + metaLinesHtml(li) + '\x3C/p>' +
          '\x3Cp class="ts-sm-s">' + (done ? 'Includes a private monogram dust bag and atelier notes.' : 'Handcrafted to order in our atelier.') + '\x3C/p>' +
          (done && reorderIds ? '\x3Cdiv class="account__order-actions">\x3Cbutton type="button" class="account__cutlink ts-sm" data-reorder="' + reorderIds + '">Reorder\x3C/button>\x3C/div>' : '') +
          '\x3C/div>\x3C/div>';
      }
      return '\x3Cdiv class="account__order">' +
        '\x3Cdiv class="account__order-meta">' +
          '\x3Cdiv>\x3Cp class="account__meta-label ts-sm-xs">Order Date\x3C/p>\x3Cp class="ts-sm-s">' + esc(fmtLong(o.processedAt)) + '\x3C/p>\x3C/div>' +
          '\x3Cdiv class="account__meta-center">\x3Cp class="account__meta-label ts-sm-xs">Total' + (multi ? ' (' + items.length + ' Pieces)' : '') + '\x3C/p>\x3Cp class="ts-sm-s">' + money(o.totalPrice.amount, o.totalPrice.currencyCode) + ' ' + esc(o.totalPrice.currencyCode) + '\x3C/p>\x3C/div>' +
          '\x3Cdiv class="account__meta-right">\x3Cp class="account__meta-label ts-sm-xs">Order No.\x3C/p>\x3Cp class="ts-sm-s">' + esc(o.name) + '\x3C/p>\x3C/div>' +
        '\x3C/div>' +
        '\x3Cdiv class="account__order-body">' +
          '\x3Cdiv class="account__order-status-row">' +
            '\x3Cdiv class="account__order-status">\x3Cspan class="account__status-dot' + (done ? '' : ' account__status-dot--craft is-pulsing') + '">\x3C/span>' + statusHtml + '\x3C/div>' +
            // a multi-piece card carries its own action beside the rail, so this slot is the
            // single-piece card's only
            (done || multi ? '' : '\x3Cbutton type="button" class="account__order-btn ts-sm" data-open-tracking>Track Progress\x3C/button>') +
          '\x3C/div>' + productHtml +
        '\x3C/div>\x3C/div>';
    }

    function renderOrders(orders) {
      var list = root.querySelector('[data-orders-list]');
      var empty = root.querySelector('[data-orders-empty]');
      if (!orders.length) { list.hidden = true; empty.hidden = false; return; }
      list.innerHTML = orders.map(orderCardHtml).join('');
      list.querySelectorAll('[data-open-tracking]').forEach(function (b) {
        b.addEventListener('click', function () { lineCut(b, openTrack); });
      });
      list.querySelectorAll('[data-reorder]').forEach(function (b) {
        b.addEventListener('click', function () { lineCut(b, function () { reorder(b); }); });
      });
    }

    // Street and unit read as one address, not two — a lone "Apt 3" line looks like an orphan on a
    // display card. Mailing labels want them split; this is a card, so they ride together.
    function addrLineParts(a) {
      var street = [a.address1, a.address2].filter(Boolean).join(', ');
      return [street, (a.city || '') + (a.zip ? ' ' + a.zip : ''), a.territoryCode].filter(Boolean).map(esc);
    }

    var addrData = null;
    function renderAddress(a) {
      // The markup's address is design copy. Returning early on a client who has saved none left
      // it standing, so a stranger's name and street read as their own — clear it instead.
      if (!a) {
        var e1 = root.querySelector('[data-ov-addr-name]'); if (e1) e1.textContent = '';
        var e2 = root.querySelector('[data-ov-addr-lines]'); if (e2) e2.textContent = 'No address saved yet.';
        addrData = null;
        return;
      }
      var name = ((a.firstName || '') + ' ' + (a.lastName || '')).trim();
      var lines = addrLineParts(a).join('\x3Cbr>');
      var n1 = root.querySelector('[data-ov-addr-name]'); if (n1) n1.textContent = name;
      var l1 = root.querySelector('[data-ov-addr-lines]'); if (l1) l1.innerHTML = lines;
      var n2 = root.querySelector('[data-addr-name]'); if (n2) n2.textContent = name;
      var l2 = root.querySelector('[data-addr-lines]'); if (l2) l2.innerHTML = lines + (a.phoneNumber ? '\x3Cbr>' + esc(a.phoneNumber) : '');
      addrData = a;
    }

    var addrBook = [];
    function addrLinesHtml(a) {
      var lines = addrLineParts(a).join('\x3Cbr>');
      return lines + (a.phoneNumber ? '\x3Cbr>' + esc(a.phoneNumber) : '');
    }
    function renderAddressBook(cu) {
      var grid = root.querySelector('[data-addr-grid]');
      if (!grid) return;
      var defId = cu.defaultAddress && cu.defaultAddress.id;
      addrBook = ((cu.addresses && cu.addresses.nodes) || []).slice().sort(function (a, b) {
        return (b.id === defId ? 1 : 0) - (a.id === defId ? 1 : 0);
      });
      grid.innerHTML = addrBook.map(function (a) {
        var isDef = a.id === defId;
        var name = esc(((a.firstName || '') + ' ' + (a.lastName || '')).trim());
        return '\x3Cdiv role="button" tabindex="0" class="account__addr-card' + (isDef ? ' account__addr-card--default' : '') + '" data-addr-id="' + esc(a.id) + '">' +
          (isDef ? '\x3Cdiv class="account__addr-badge ts-sm">Default\x3C/div>' : '') +
          '\x3Ch5 class="account__addr-card-name ts-sub-s">' + name + '\x3C/h5>' +
          '\x3Cp class="account__addr-card-lines ts-sub-xs">' + addrLinesHtml(a) + '\x3C/p>' +
          (isDef ? '' : '\x3Cbutton type="button" class="account__cutlink ts-sm" data-set-default="' + esc(a.id) + '">Set Default\x3C/button>') +
        '\x3C/div>';
      }).join('') +
        '\x3Cbutton type="button" class="account__addr-add" data-open-addr-form-new>' +
          '\x3Csvg viewBox="0 0 24 24" fill="none" stroke="currentColor">\x3Cpath stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M12 4v16m8-8H4">\x3C/path>\x3C/svg>' +
          '\x3Cspan class="account__muted ts-sm">Add New Address\x3C/span>' +
        '\x3C/button>';
      function findAddr(id) {
        var m = null;
        addrBook.forEach(function (x) { if (x.id === id) m = x; });
        return m;
      }
      grid.querySelectorAll('[data-addr-id]').forEach(function (card) {
        function edit() { openAddrForm(true, findAddr(card.getAttribute('data-addr-id'))); }
        card.addEventListener('click', edit);
        card.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); edit(); }
        });
      });
      grid.querySelectorAll('[data-set-default]').forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.stopPropagation();
          withCaa(function (C) {
            C.query('mutation SetDefaultAddr($id: ID!){ customerAddressUpdate(addressId: $id, defaultAddress: true){ customerAddress { id } userErrors { field message } } }',
              { id: b.getAttribute('data-set-default') })
              .then(function (r) {
                var errs = r.data && r.data.customerAddressUpdate && r.data.customerAddressUpdate.userErrors;
                if (errs && errs.length) { showToast(errs[0].message); return; }
                showToast('Default address updated.');
                load(C);
              }).catch(function () { showToast('Could not update. Please try again.'); });
          });
        });
      });
      var addBtn = grid.querySelector('[data-open-addr-form-new]');
      if (addBtn) addBtn.addEventListener('click', function () { openAddrForm(false); });
    }

    var customerId = null, wlEntries = [];
    function renderWaitlistTab(metafield) {
      var entries = [];
      try { entries = JSON.parse((metafield && metafield.value) || '[]'); } catch (e) {}
      wlEntries = entries;
      var cnt = root.querySelector('[data-waitlist-count]'); if (cnt) cnt.textContent = '(' + entries.length + ')';
      var grid = root.querySelector('[data-wl-grid]');
      if (!entries.length) { grid.innerHTML = '\x3Cp class="account__empty-copy ts-sub-xs" style="grid-column:1/-1;text-align:center;">No private requests yet. Sold-out pieces offer a waitlist option on their product page.\x3C/p>'; updateWlReadyCount(); return; }
      grid.innerHTML = '';
      entries.forEach(function (entry) {
        var parts = String(entry).split(':');
        var handle = parts[0], vid = parts[1];
        fetch((ACC.root || '/').replace(new RegExp('/+$'), '') + '/products/' + handle + '?view=wl')
          .then(function (r) { return r.text(); }).then(function (tx) {
            var p = JSON.parse(tx);
            var v = null;
            (p.variants || []).forEach(function (x) { if (String(x.id) === String(vid)) v = x; });
            v = v || (p.variants || [])[0] || {};
            var ready = !!v.available;
            var imgUrl = v.image || p.image;
            // 4.0 card copy: flat head grid (reflows to "title price" / "variant rm" on mobile, stacks on desktop);
            // multi-option variant titles ("Black / Calfskin") break one option per line
            // ?view=wl already returns the leather — carry it onto its own line so a waitlist card
            // reads the same as an order card: colour, then material. Same rule the standalone
            // /pages/waitlist uses, dedupe included, so the two lists never disagree.
            var vParts = (v.title && v.title !== 'Default Title') ? String(v.title).split(' / ').map(esc) : [];
            if (p.leather && vParts.indexOf(esc(p.leather)) === -1) vParts.push(esc(p.leather));
            var variantLines = vParts.join('\x3Cbr>');
            var rmBtn = ready ? '\x3Cbutton type="button" class="account__cutlink account__wl-rm ts-sm" data-entry="' + esc(entry) + '" aria-label="Remove">RM\x3C/button>' : '';
            var statusInner = ready
              ? '\x3Cspan class="account__wl-pulse">\x3C/span>\x3Cspan class="ts-sm">Ready to Secure\x3C/span>'
              : '\x3Cspan class="account__wl-hollow">\x3C/span>' + (v.release_note
                  ? '\x3Cspan class="account__wl-status-desk ts-sm">In Production\x3C/span>\x3Cspan class="account__wl-status-mob ts-sm">Expected ' + esc(v.release_note) + '\x3C/span>'
                  : '\x3Cspan class="ts-sm">In Production\x3C/span>');
            grid.insertAdjacentHTML('beforeend',
              '\x3Carticle data-waitlist-status="' + (ready ? 'ready' : 'production') + '" class="account__wl-card">' +
                '\x3Cdiv class="account__wl-media">' + (imgUrl ? '\x3Cimg class="account__wl-img" src="' + esc(imgUrl + (String(imgUrl).indexOf('?') > -1 ? '&' : '?') + 'width=600') + '" alt="' + esc(p.title) + '" width="600" height="750" loading="lazy">' : '') + '\x3C/div>' +
                '\x3Cdiv class="account__wl-body">' +
                  '\x3Cdiv class="account__wl-head">' +
                    '\x3Ch4 class="account__wl-title ts-h-l">' + esc(p.title) + '\x3C/h4>' +
                    (variantLines ? '\x3Cp class="account__wl-variant ts-sm-xs">' + variantLines + '\x3C/p>' : '') +
                    '\x3Cp class="account__wl-price ts-sm-l">' + money((v.price || 0) / 100) + '\x3C/p>' + rmBtn +
                  '\x3C/div>' +
                  '\x3Cdiv class="account__wl-status">' + statusInner + '\x3C/div>' +
                  (ready ? '\x3Cdiv class="account__wl-actions">\x3Cbutton type="button" class="account__wl-primary ts-sm" data-vid="' + esc(v.id) + '">Secure Allocation\x3C/button>\x3Cbutton type="button" class="account__wl-ghost ts-sm" data-entry="' + esc(entry) + '">Remove\x3C/button>\x3C/div>'
                         : '\x3Cdiv class="account__wl-foot">\x3Cp class="account__wl-release ts-sub-s">' + esc(v.release_note ? 'Expected release: ' + v.release_note : 'We will email you when the atelier reopens this piece.') + '\x3C/p>\x3Cbutton type="button" class="account__cutlink account__wl-remove-desktop ts-sm" data-entry="' + esc(entry) + '">Remove\x3C/button>\x3C/div>') +
                '\x3C/div>\x3C/article>');
            grid.querySelectorAll('[data-vid]').forEach(function (b) {
              if (b.__bound) return; b.__bound = 1;
              b.addEventListener('click', function () {
                secureSequence(b);
                document.dispatchEvent(new CustomEvent('arforti:cart-add', { detail: { id: b.getAttribute('data-vid') } }));
              });
            });
            grid.querySelectorAll('[data-entry]').forEach(function (b) {
              if (b.__bound) return; b.__bound = 1;
              b.addEventListener('click', function () { removeEntry(b.getAttribute('data-entry'), b); });
            });
            updateWlReadyCount(); // recount as each card's ready/production state resolves
          }).catch(function () {});
      });
    }

    // Confirm-first remove (mirrors the waitlist page + CLAUDE.md §6): the card stays put while the
    // metafield write is in flight and only leaves AFTER the server confirms, fading just THAT card
    // (no full re-render — so the remove link's underline-cut is never stomped). On failure the card
    // stays and a toast reports it. Previously: .then re-rendered the whole tab (cut got stomped on
    // fast writes) with no .catch (silent failure).
    var removingWl = {};
    function removeEntry(entry, btn) {
      if (removingWl[entry]) return;
      removingWl[entry] = true;
      var card = btn && btn.closest('.account__wl-card');
      if (card) card.classList.add('is-removing');
      withCaa(function (C) {
        var next = wlEntries.filter(function (x) { return x !== entry; });
        C.query('mutation($m:[MetafieldsSetInput!]!){metafieldsSet(metafields:$m){userErrors{field message}}}',
          { m: [{ ownerId: customerId, namespace: ACC.wlNs || 'custom', key: ACC.wlKey || 'waitlist', type: 'json', value: JSON.stringify(next) }] })
          .then(function (r) {
            var errs = r && r.data && r.data.metafieldsSet && r.data.metafieldsSet.userErrors;
            if (!r || r.errors || (errs && errs.length)) throw new Error('write rejected');
            wlEntries = next;
            delete removingWl[entry];
            showToast('Interest removed.');
            var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            if (!card || reduced) { if (card) card.remove(); afterWaitlistRemove(); return; }
            card.style.transition = 'opacity 0.4s ease'; card.style.opacity = '0';
            setTimeout(function () { card.remove(); afterWaitlistRemove(); }, 400);
          })
          .catch(function () {
            delete removingWl[entry];
            if (card) card.classList.remove('is-removing');
            showToast('Couldn’t remove — please try again.');
          });
      });
    }
    // recount + empty state after a confirmed removal (no full re-render unless the list is now empty)
    function afterWaitlistRemove() {
      var grid = root.querySelector('[data-wl-grid]');
      if (!grid) return;
      var remaining = grid.querySelectorAll('.account__wl-card').length;
      var cnt = root.querySelector('[data-waitlist-count]'); if (cnt) cnt.textContent = '(' + remaining + ')';
      updateWlReadyCount();
      if (!remaining) renderWaitlistTab({ value: '[]' });
    }
    // "(N)" on the Ready Secure tab = securable cards currently in the grid (matches the waitlist page).
    // Recomputed from the DOM after cards render/remove, since a card's ready state is only known
    // once its product JSON loads.
    function updateWlReadyCount() {
      var el = root.querySelector('[data-wl-ready-count]');
      if (!el) return;
      var n = root.querySelectorAll('.account__wl-card[data-waitlist-status="ready"]').length;
      el.textContent = '(' + n + ')';
    }

    function saveAddress(C) {
      var addr = {
        lastName: document.getElementById('acc-lname').value,
        firstName: document.getElementById('acc-fname').value,
        phoneNumber: document.getElementById('acc-phone').value,
        address1: document.getElementById('acc-street').value,
        city: document.getElementById('acc-city').value,
        zip: document.getElementById('acc-zip').value
      };
      var saveBtn = root.querySelector('[data-addr-save]');
      var oldTxt = saveBtn ? saveBtn.textContent : '';
      if (saveBtn) { saveBtn.textContent = 'Saving...'; saveBtn.classList.add('is-busy'); }
      function settle() { if (saveBtn) { saveBtn.textContent = oldTxt; saveBtn.classList.remove('is-busy'); } }
      var op, vars;
      if (editingAddr && editingAddr.id) {
        op = 'mutation UpdAddr($id: ID!, $addr: CustomerAddressInput!){ customerAddressUpdate(addressId: $id, address: $addr){ customerAddress { id } userErrors { field message } } }';
        vars = { id: editingAddr.id, addr: addr };
      } else {
        addr.territoryCode = (addrData && addrData.territoryCode) || 'US';
        op = 'mutation CreateAddr($addr: CustomerAddressInput!){ customerAddressCreate(address: $addr){ customerAddress { id } userErrors { field message } } }';
        vars = { addr: addr };
      }
      C.query(op, vars)
        .then(function (r) {
          settle();
          var pl = r.data && (r.data.customerAddressUpdate || r.data.customerAddressCreate);
          var errs = pl && pl.userErrors;
          if (!pl || (errs && errs.length)) { showToast(errs && errs.length ? errs[0].message : 'Could not save. Please try again.'); return; }
          showToast('Address details saved to your profile.');
          closeAddrForm();
          load(C);
        }).catch(function () { settle(); showToast('Could not save. Please try again.'); });
    }

    function load(C) {
      C.query(Q).then(function (r) {
        var cu = r && r.data && r.data.customer;
        if (!cu) { gate(true); return; }
        customerId = cu.id;
        gate(false);
        setAccountName(cu.firstName || (cu.emailAddress && cu.emailAddress.emailAddress) || 'Client');
        renderOverview(cu.orders.nodes || []);
        renderOrders(cu.orders.nodes || []);
        renderAddress(cu.defaultAddress);
        renderAddressBook(cu);
        renderWaitlistTab(cu.metafield);
        root.classList.remove('account--loading'); // real data is in; skeletons hand over
      }).catch(function () { gate(true); });
    }

    // ponytail: design/QA preview. ?demo (or ?demo=bundle / ?demo=single)
    // ungates and shows the static demo content without a login or real data.
    function demoWaitlist() {
      var grid = root.querySelector('[data-wl-grid]');
      if (!grid) return;
      var cards = [
        { status: 'ready', title: 'The Masterpiece', variant: 'Classic Noir\x3Cbr>Tuscan Calfskin', price: '$389', img: 'https://images.unsplash.com/photo-1548036328-c9fa89d128fa?auto=format&fit=crop&w=600&q=80' },
        { status: 'production', title: 'The Masterpiece', variant: 'Soft Taupe\x3Cbr>Hand-Polished Finish', price: '$415', release: 'late October', img: 'https://images.unsplash.com/photo-1566150905458-1bf1fc113f0d?auto=format&fit=crop&w=600&q=80' },
        { status: 'production', title: 'The Mini Arc', variant: 'Ivory\x3Cbr>Smooth Calfskin', price: '$245', release: 'early November', img: 'https://images.unsplash.com/photo-1590874103328-eac38a683ce7?auto=format&fit=crop&w=600&q=80' }
      ];
      grid.innerHTML = cards.map(function (d) {
        var ready = d.status === 'ready';
        var rmBtn = ready ? '\x3Cbutton type="button" class="account__cutlink account__wl-rm ts-sm" aria-label="Remove">RM\x3C/button>' : '';
        var statusInner = ready
          ? '\x3Cspan class="account__wl-pulse">\x3C/span>\x3Cspan class="ts-sm">Ready to Secure\x3C/span>'
          : '\x3Cspan class="account__wl-hollow">\x3C/span>\x3Cspan class="account__wl-status-desk ts-sm">In Production\x3C/span>\x3Cspan class="account__wl-status-mob ts-sm">Expected ' + d.release + '\x3C/span>';
        return '\x3Carticle data-waitlist-status="' + d.status + '" class="account__wl-card">' +
          '\x3Cdiv class="account__wl-media">\x3Cimg class="account__wl-img" src="' + d.img + '" alt="' + d.title + '" width="600" height="750">\x3C/div>' +
          '\x3Cdiv class="account__wl-body">' +
            '\x3Cdiv class="account__wl-head">' +
              '\x3Ch4 class="account__wl-title ts-h-l">' + d.title + '\x3C/h4>' +
              '\x3Cp class="account__wl-variant ts-sm-xs">' + d.variant + '\x3C/p>' +
              '\x3Cp class="account__wl-price ts-sm-l">' + d.price + '\x3C/p>' + rmBtn +
            '\x3C/div>' +
            '\x3Cdiv class="account__wl-status">' + statusInner + '\x3C/div>' +
            (ready ? '\x3Cdiv class="account__wl-actions">\x3Cbutton type="button" class="account__wl-primary ts-sm">Secure Allocation\x3C/button>\x3Cbutton type="button" class="account__wl-ghost ts-sm">Remove\x3C/button>\x3C/div>'
                   : '\x3Cdiv class="account__wl-foot">\x3Cp class="account__wl-release ts-sub-s">Expected release: ' + d.release + '\x3C/p>\x3Cbutton type="button" class="account__cutlink account__wl-remove-desktop ts-sm">Remove\x3C/button>\x3C/div>') +
          '\x3C/div>\x3C/article>';
      }).join('');
      var cnt = root.querySelector('[data-waitlist-count]'); if (cnt) cnt.textContent = '(' + cards.length + ')';
      updateWlReadyCount();
      grid.querySelectorAll('.account__wl-primary').forEach(function (b) { b.addEventListener('click', function () { secureSequence(b, function () { showToast('Allocation secured in demo mode.'); }); }); });
      grid.querySelectorAll('.account__wl-ghost, .account__wl-remove-desktop, .account__wl-rm').forEach(function (b) {
        if (b.__bound) return; b.__bound = 1;
        b.addEventListener('click', function () {
          showToast('Interest removed in demo mode.');
          var card = b.closest('.account__wl-card'); if (!card) return;
          var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          card.classList.add('is-removing');
          if (reduced) { card.remove(); afterWaitlistRemove(); return; }
          card.style.transition = 'opacity 0.4s ease'; card.style.opacity = '0';
          setTimeout(function () { card.remove(); afterWaitlistRemove(); }, 400);
        });
      });
    }

    // ?demo=real: the only preview that tells the truth. Builds two orders out of live products
    // and hands them to renderOverview/renderOrders — the exact functions the signed-in path uses —
    // so every label, every fallback and every empty field is the one a client actually gets.
    function demoRealOrders() {
      var el = root.querySelector('[data-demo-lineitems]');
      if (!el) return null;
      var items;
      try { items = JSON.parse(el.textContent); } catch (e) { return null; }
      if (!items || !items.length) return null;
      var ago = function (days) { return new Date(Date.now() - days * 86400000).toISOString(); };
      var money = function (n) { return { amount: String(n), currencyCode: 'USD' }; };
      return [
        {
          id: 'gid://shopify/Order/9001',
          name: '#1002',
          processedAt: ago(6), // mid-atelier, so the progress rail sits in a real phase
          fulfillmentStatus: 'UNFULFILLED',
          fulfillments: { nodes: [] },
          totalPrice: money('480.00'),
          lineItems: { nodes: [items[0]] }
        },
        {
          id: 'gid://shopify/Order/9000',
          name: '#1001',
          processedAt: ago(34),
          fulfillmentStatus: 'FULFILLED',
          fulfillments: { nodes: [{
            latestShipmentStatus: 'DELIVERED',
            trackingInformation: [{ company: 'DHL Express', number: 'JD014600009876543210', url: 'https://www.dhl.com/en/express/tracking.html?AWB=JD014600009876543210' }],
            fulfillmentLineItems: { nodes: items.slice(1).map(function (it) { return { quantity: 1, lineItem: { name: it.name } }; }) }
          }] },
          totalPrice: money('960.00'),
          lineItems: { nodes: items.slice(1) }
        }
      ];
    }

    var demoMatch = /[?&]demo(?:=([^&]*))?/.exec(location.search);
    if (demoMatch && demoMatch[1] === 'real') {
      gate(false);
      root.classList.remove('account--loading');
      setAccountName('Genevieve', true);
      var realOrders = demoRealOrders();
      if (realOrders) { renderOverview(realOrders); renderOrders(realOrders); }
      var demoAddr = {
        id: 'gid://shopify/CustomerAddress/1', firstName: 'Genevieve', lastName: 'Aldridge',
        phoneNumber: '+1 415 555 0148', address1: '1142 Greenwich Street', address2: 'Apt 3',
        city: 'San Francisco', zip: 'CA 94109', territoryCode: 'US'
      };
      renderAddress(demoAddr);
      renderAddressBook({ defaultAddress: demoAddr, addresses: { nodes: [demoAddr] } });
      demoWaitlist();
    } else if (demoMatch && demoMatch[1] === 'loading') {
      gate(false); // ?demo=loading: hold the skeleton state (name + all regions) for design review
    } else if (demoMatch) {
      gate(false);
      root.classList.remove('account--loading'); // demo mode wants the mock content visible
      setAccountName('Genevieve', true); // noCache: the mock name must never pollute a real session
      var single = root.querySelector('[data-ov-single]');
      var bundle = root.querySelector('[data-ov-bundle]');
      if (demoMatch[1] === 'bundle') {
        if (single) single.hidden = true;
        if (bundle) bundle.hidden = false;
      } else {
        if (single) single.hidden = false;
        if (bundle) bundle.hidden = true;
      }
      demoWaitlist();

      // ?demo=empty: a signed-in client who has not ordered yet — both empty states, no scrubber
      if (demoMatch[1] === 'empty') {
        var eCard = root.querySelector('[data-ov-order]');
        var eEmpty = root.querySelector('[data-ov-empty]');
        var eOrders = root.querySelector('[data-orders-empty]');
        var eList = root.querySelector('[data-orders-list]');
        if (eCard) eCard.hidden = true;
        if (eEmpty) eEmpty.hidden = false;
        if (eOrders) eOrders.hidden = false;
        if (eList) eList.hidden = true;
        // both address surfaces, not just the overview — otherwise the preview keeps showing the
        // placeholder card and hides the very state it is meant to demonstrate
        renderAddress(null);
        renderAddressBook({ defaultAddress: null, addresses: { nodes: [] } });
        return;
      }

      var scrub = root.querySelector('[data-scrub]');
      if (scrub) {
        var scrubRange = scrub.querySelector('[data-scrub-range]');
        var scrubDay = scrub.querySelector('[data-scrub-day]');
        var scrubShip = scrub.querySelector('[data-scrub-shipped]');
        var paintScrub = function () {
          var d = +scrubRange.value;
          // a partially fulfilled order is never FULFILLED, so the remainder keeps its
          // in-atelier badge even while the first parcel is already on its way
          isFulfilled = scrubShip.checked && !isPartial;
          allTracking = (demoTracking && scrubShip.checked) ? demoTracking : [];
          scrubDay.textContent = d >= 16 ? '16+' : d;
          updateProgress(d);
        };
        scrubRange.addEventListener('input', paintScrub);
        scrubShip.addEventListener('change', paintScrub);
        scrub.hidden = false;
        paintScrub();
      }

      var demoUrl = 'https://www.dhl.com/en/express/tracking.html?AWB=JD014600009876543210';
      if (demoMatch[1] === 'notrack') {
        demoTracking = [{ company: 'DHL Express', number: 'JD014600009876543210', url: null }];
      } else if (demoMatch[1] === 'split') {
        demoTracking = [
          { company: 'DHL Express', number: 'JD014600009876543210', url: demoUrl },
          { company: 'FedEx', number: '772387654321', url: 'https://www.fedex.com/fedextrack/?trknbr=772387654321' }
        ];
      } else {
        demoTracking = [{ company: 'DHL Express', number: 'JD014600009876543210', url: demoUrl }];
      }
      isPartial = demoMatch[1] === 'partial' || demoMatch[1] === 'three';
      if (demoMatch[1] === 'three') {
        demoTracking = [{ company: 'DHL Express', number: 'JD014600009876543210', url: demoUrl, items: ['The Masterpiece'] }];
        restItems = ['ALIR', 'Wharton'];
      } else if (demoMatch[1] === 'partial') {
        demoTracking[0].items = ['The Masterpiece'];
        restItems = ['ALIR'];
      }
      liveCarrier = demoTracking[0].company;
      paintTrackLink();
    } else {
      withCaa(function (C) {
        var loginBtn = document.querySelector('[data-acc-login]');
        if (loginBtn) loginBtn.addEventListener('click', function () { loginBtn.classList.add('is-pulse'); C.login(); });
        if (logoutBtn) logoutBtn.addEventListener('click', function () { try { localStorage.removeItem('caa_name'); } catch (e) {} C.logout(); });
        if (/[?&]code=/.test(location.search)) {
          C.handleCallback().then(function () { load(C); }).catch(function () { gate(true); });
        } else if (C.isLoggedIn()) {
          load(C);
        } else {
          gate(true);
        }
        if (addrFormEl) addrFormEl.addEventListener('submit', function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          if (!addrFormEl.checkValidity()) { addrFormEl.reportValidity(); return; }
          saveAddress(C);
        }, true);
      });
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  /* Decode-failure fallback for the HLS sources rendered by snippets/video-hls.liquid. It rides on
     the drawer for the same reason the quick-add words do: this is the one section on every page,
     and a section-JS block inside a snippet is never bundled (verified against scripts.js). Do not
     name that tag in here — spelling it out makes Liquid read it as a real nested tag and reject
     the file, which is what happened on the first attempt at this comment.

     canPlayType is allowed to guess. For HLS it has historically guessed "maybe" in browsers that
     then could not decode a frame, and such a video is silently dead — source selection succeeded,
     so nothing else here notices. Catching the decode error and handing that element the mp4 costs
     one listener and removes the only way this change can make a page worse than it was. */
  (function () {
    document.addEventListener(
      'error',
      function (e) {
        const v = e.target;
        if (!v || v.tagName !== 'VIDEO' || v.dataset.hlsFallback) return;
        const mp4 = v.querySelector('source[type="video/mp4"]');
        if (!mp4 || !mp4.getAttribute('src')) return;
        v.dataset.hlsFallback = '1';
        v.src = mp4.getAttribute('src');
        v.load();
        if (v.autoplay) {
          const p = v.play();
          if (p && p.catch) p.catch(function () {});
        }
      },
      true /* media errors do not bubble; capture is the only way to hear them from the document */
    );
  })();

  (function () {
    const drawer = document.querySelector('[data-cart]');
    if (!drawer) return;
    try { console.info('%c[ARFORTI cart] build: ' + (drawer.dataset.cartBuild || '?'), 'color:#9a3f35'); } catch (e) {}
    const SECTION_ID = drawer.closest('.shopify-section')?.id?.replace('shopify-section-', '') || 'cart-drawer';

    /* Quick-add feedback for every [data-add-variant] button in the store — collection, search and
       Complete the Look all hand their add to this drawer, so the button state belongs here too
       rather than being written into each card. The dispatch stays with the cards; this only
       swaps the label: "Add to Cart" → breathing "Adding…" → "Added", matching the product page. */
    let pendingAdd = null;
    let pendingTimer = null;
    const restore = (b) => {
      if (!b) return;
      b.classList.remove('is-adding', 'is-added');
      if (b.dataset.addLabel != null) b.textContent = b.dataset.addLabel;
    };
    document.addEventListener(
      'click',
      (e) => {
        const b = e.target.closest?.('[data-add-variant]');
        if (!b || b.disabled) return;
        clearTimeout(pendingTimer);
        restore(pendingAdd);
        pendingAdd = b;
        if (b.dataset.addLabel == null) b.dataset.addLabel = b.textContent.trim();
        b.textContent = drawer.dataset.addingLabel || 'Adding…';
        b.classList.add('is-adding');
      },
      true
    );
    document.addEventListener('arforti:cart-added', (e) => {
      const b = pendingAdd;
      pendingAdd = null;
      if (!b) return;
      b.classList.remove('is-adding');
      if (!(e.detail && e.detail.ok)) return restore(b);
      b.textContent = drawer.dataset.addedLabel || 'Added';
      b.classList.add('is-added');
      pendingTimer = setTimeout(() => restore(b), 1400);
    });

    let lastFocus = null;
    let closeTimer = null;
    const open = () => {
      clearTimeout(closeTimer); // cancel a pending hide so a quick re-open isn't closed again
      lastFocus = document.activeElement;
      drawer.hidden = false;
      requestAnimationFrame(() => {
        drawer.classList.add('is-open');
        const f = drawer.querySelector('[data-cart-close]');
        if (f) f.focus();
      });
      document.body.style.overflow = 'hidden';
    };
    const close = () => {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
      clearTimeout(closeTimer);
      closeTimer = setTimeout(() => { drawer.hidden = true; }, 700);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    };

    document.addEventListener('click', (e) => {
      const opener = e.target.closest('[data-cart-open]');
      if (opener) { e.preventDefault(); open(); } // the drawer is already server-rendered + updated after every op, so just show it
    });
    drawer.querySelectorAll('[data-cart-close]').forEach((b) => b.addEventListener('click', close));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !drawer.hidden) close(); });

    // Checkout navigates away, so nothing in here gets to report back — the state goes on at submit
    // and the page leaving is what clears it. Delegated: the footer this button lives in is replaced
    // wholesale by renderHtml() after every cart write, so a direct binding would not survive.
    // Deliberately NOT btn.disabled: a disabled submitter is dropped from the POST body, and without
    // name="checkout" the request would just update the cart instead of going to checkout.
    drawer.addEventListener('submit', (e) => {
      const btn = e.target.querySelector('.cart-drawer__checkout');
      if (btn) btn.classList.add('is-loading');
    });
    // Backing out of checkout can restore this page from bfcache with the button still breathing.
    window.addEventListener('pageshow', () => {
      drawer.querySelectorAll('.cart-drawer__checkout.is-loading').forEach((b) => b.classList.remove('is-loading'));
    });

    // Focus trap: keep Tab within the open drawer (a11y).
    drawer.addEventListener('keydown', (e) => {
      if (e.key !== 'Tab' || drawer.hidden) return;
      const list = Array.from(drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter((el) => el.offsetParent !== null);
      if (!list.length) return;
      const first = list[0], last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    const setBusy = (b) => drawer.classList.toggle('is-busy', b);
    const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const wait = (ms) => new Promise((r) => setTimeout(r, ms));

    function renderHtml(html) {
      if (!html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-cart-inner]');
      const current = drawer.querySelector('[data-cart-inner]');
      if (fresh && current) current.innerHTML = fresh.innerHTML;
    }

    function updateCount(n) {
      if (typeof n !== 'number' || isNaN(n)) return;
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = n;
        const dot = el.closest('.header__cart-dot');
        if (dot) dot.classList.toggle('is-empty', n === 0);
      });
    }
    function syncCountFromDom() {
      const el = drawer.querySelector('[data-cart-total-count]');
      if (el) updateCount(parseInt(el.textContent, 10));
    }

    // availability / error note so capped or rejected actions (e.g. "Only 1 available") aren't silent
    let noteTimer = null;
    function showNote(msg) {
      const note = drawer.querySelector('[data-cart-note]');
      if (!note || !msg) return;
      note.textContent = msg;
      note.hidden = false;
      clearTimeout(noteTimer);
      noteTimer = setTimeout(() => { note.hidden = true; }, 4000);
    }
    function hideNote() {
      const note = drawer.querySelector('[data-cart-note]');
      if (note) { note.hidden = true; clearTimeout(noteTimer); }
    }

    // ---- Cart writes ----
    // Writes are SERIALIZED (one at a time, in click order) so their re-renders apply in order. If
    // they ran concurrently, a slow/older response could overwrite a fresher render → stale count,
    // "delete didn't update", or a stale quantity that corrupts the next +/- . Each fetch has an 8s
    // timeout (tfetch), so a hung request can NEVER block the queue forever (that was the old freeze).
    // Every write is sent WITH `sections`, renders from the server's HTML, and clears its loading
    // state in finally() so nothing stays grey.
    let writeChain = Promise.resolve();
    const enqueueWrite = (fn) => { const p = writeChain.then(fn, fn); writeChain = p.catch(() => {}); return p; };

    // fetch with a hard timeout — a hung request aborts instead of blocking the whole serialized queue forever
    function tfetch(url, opts, ms) {
      const ac = new AbortController();
      const id = setTimeout(() => ac.abort(), ms || 8000);
      return fetch(url, Object.assign({ signal: ac.signal }, opts || {})).finally(() => clearTimeout(id));
    }

    // network/timeout recovery only: re-render the drawer from the true cart via the Section Rendering
    // API (the returned section HTML already contains the count, so one request is enough).
    async function resync() {
      try { const r = await tfetch(root() + '?sections=' + SECTION_ID); if (r.ok) { const j = await r.json(); if (j && j[SECTION_ID]) { renderHtml(j[SECTION_ID]); syncCountFromDom(); } } } catch (e) {}
    }

    async function cartWrite(endpoint, body) {
      setBusy(true);
      try {
        let headers = { Accept: 'application/json' }, payload;
        if (body instanceof FormData) {
          body.append('sections', SECTION_ID); body.append('sections_url', window.location.pathname);
          payload = body;
        } else {
          headers['Content-Type'] = 'application/json';
          payload = JSON.stringify(Object.assign({ sections: SECTION_ID, sections_url: window.location.pathname }, body));
        }
        // Shopify's edge throttles cart endpoints with a leaky bucket → HTTP 429 (a non-JSON page, so
        // res.json() → {}). The fix is to wait for the bucket to drain and retry the SAME request. We stay
        // 'is-busy' through the backoff so the shopper can't keep clicking and refill the bucket — that
        // self-inflicted pile-up is what made every button feel dead after the first 429.
        let res, data;
        for (let attempt = 0; ; attempt++) {
          res = await tfetch(root() + endpoint, { method: 'POST', headers, body: payload });
          data = await res.json().catch(() => ({})); // non-JSON (429 throttle / 430 security page) → {}
          if (res.status !== 429 || attempt >= 2) break;
          const ra = parseInt(res.headers.get('Retry-After'), 10); // seconds, if Shopify sends it
          const backoff = Math.min((ra > 0 ? ra * 1000 : 800 * (attempt + 1)), 5000);
          try { console.warn('[ARFORTI cart] ' + endpoint + ' HTTP 429 — retry ' + (attempt + 1) + '/2 in ' + backoff + 'ms'); } catch (e) {}
          showNote('One moment…');
          await wait(backoff);
        }
        if (!res.ok) { try { console.warn('[ARFORTI cart] ' + endpoint + ' HTTP ' + res.status, data); } catch (e) {} }
        const html = data.sections && data.sections[SECTION_ID];
        if (html) { renderHtml(html); syncCountFromDom(); } // server-rendered drawer = the single source of truth
        // On an error the cart is unchanged and the shown values are already correct, so just surface a
        // message. 429 = still throttled after retries (Shopify's own message is a non-JSON page, so use ours);
        // 422 over-stock etc. carry Shopify's own message (e.g. "Only 1 available").
        if (res.ok) hideNote();
        else if (res.status === 429) showNote('Too many requests — please wait a moment and try again.');
        else if (res.status === 422) showNote('Atelier Notice: Insufficient workshop inventory.'); // over-stock — atelier copy ported from the waitlist source
        else showNote((data && data.message) || 'Couldn’t update the cart — please try again');
        return { ok: res.ok, message: (data && data.message) || '' };
      } catch (e) {
        try { console.warn('[ARFORTI cart] ' + endpoint + ' network/timeout error', e && (e.name || e.message)); } catch (_) {}
        showNote('Network error — please try again');
        await resync(); // timeout / network error → never leave the drawer stuck; pull the truth
        return { ok: false, message: '', data: null };
      } finally {
        setBusy(false);
        drawer.querySelectorAll('.cart-drawer__item.is-updating').forEach((r) => r.classList.remove('is-updating')); // never leave a line stuck grey
      }
    }

    // Single-item form { id, quantity } — NOT { items: [...] }: the items-array form spuriously returns
    // 422 "maximum quantity already in your cart" on a re-add of an item already in the cart, while the
    // single form (same as the product page) increments correctly. Verified against the live cart.
    const addItem = (variantId) => enqueueWrite(() => cartWrite('cart/add.js', { id: variantId, quantity: 1 }).then((r) => {
      if (r && r.ok) open(); // open the drawer only AFTER the add actually succeeds
      document.dispatchEvent(new CustomEvent('arforti:cart-added', { detail: { ok: !!(r && r.ok), message: (r && r.ok) ? '' : ((r && r.message) || 'Already in your bag') } }));
    }));

    // Allow other sections (e.g. the waitlist "Secure" button) to add + open the drawer.
    document.addEventListener('arforti:cart-add', (e) => { if (e.detail && e.detail.id) addItem(e.detail.id); });

    const timers = {};
    function step(btn, delta) {
      if (drawer.classList.contains('is-busy')) return; // one write at a time — ignore taps until the current one finishes
      const row = btn.closest('[data-line-key]');
      if (!row) return;
      const key = btn.dataset.key;
      const numEl = row.querySelector('[data-qty-num]');
      const q = Math.max(0, (parseInt(numEl ? numEl.textContent : '1', 10) || 0) + delta); // computed from the SHOWN (server-true) qty, so it can never drift
      row.classList.add('is-updating'); // loading hint while the server confirms
      clearTimeout(timers[key]);
      timers[key] = setTimeout(() => enqueueWrite(() => cartWrite('cart/change.js', { id: key, quantity: q })), 180);
    }

    function removeItem(btn) {
      const row = btn.closest('[data-line-key]');
      if (!row) return;
      const key = btn.dataset.key;
      btn.classList.add('cart-drawer__remove--cutting'); // button underline cut — click feedback only
      // Dim the row (SAME as +/-) and let the server re-render do the actual removal, so the item
      // disappears AT THE SAME MOMENT the price/count update — no early fade-out that left the price stale.
      row.classList.add('is-updating');
      enqueueWrite(() => cartWrite('cart/change.js', { id: key, quantity: 0 }));
    }

    drawer.addEventListener('click', (e) => {
      const dec = e.target.closest('[data-qty-step="dec"]');
      const inc = e.target.closest('[data-qty-step="inc"]');
      const rm = e.target.closest('[data-remove]');
      const add = e.target.closest('[data-cross-add]');
      if (dec) step(dec, -1);
      else if (inc) step(inc, 1);
      else if (rm) removeItem(rm);
      else if (add && add.dataset.variantId) addItem(add.dataset.variantId);
    });

    function addFromForm(form) {
      enqueueWrite(() => cartWrite('cart/add.js', new FormData(form)).then((r) => {
        if (r && r.ok) open(); // open only after success
        // same report the event path sends, so a form-submitted add can settle its own button
        document.dispatchEvent(new CustomEvent('arforti:cart-added', { detail: { ok: !!(r && r.ok), message: (r && r.ok) ? '' : ((r && r.message) || 'Already in your bag') } }));
      }));
    }

    document.addEventListener('submit', (e) => {
      const form = e.target.closest('form[action$="/cart/add"]');
      if (!form) return;
      e.preventDefault();
      addFromForm(form);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["complete-look"] && !Shopify.designMode) return;
  try {
    
  /* Hand the add off to the cart drawer, which owns the add, the open and the 429 retry — the same
     contract assets/search.js uses for the collection cards. This section only renders on a product
     page, where search.js is not loaded, so pulling that whole file in for one button would be waste. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-add-variant]') : null;
    if (!btn || !btn.closest('.complete-look')) return;
    e.preventDefault();
    var id = btn.getAttribute('data-add-variant');
    if (id) document.dispatchEvent(new CustomEvent('arforti:cart-add', { detail: { id: id } }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["concierge"]) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-concierge]');
    if (!root) return;
    const drawer = root.querySelector('[data-concierge-drawer]');
    if (!drawer) return;
    // scroll lock is a mobile-sheet behaviour; the desktop popover leaves the page scrollable
    const isMobileSheet = () => window.matchMedia('(max-width: 1023px)').matches;
    const open = () => { drawer.hidden = false; void drawer.offsetWidth; drawer.classList.add('is-open'); if (isMobileSheet()) document.body.style.overflow = 'hidden'; }; // forced reflow paints the closed frame so the slide always runs
    const close = () => { drawer.classList.remove('is-open'); document.body.style.overflow = ''; setTimeout(() => { drawer.hidden = true; }, 700); };
    const toggle = () => { if (!drawer.hidden && drawer.classList.contains('is-open')) close(); else open(); }; // the trigger also retracts an open card
    root.querySelectorAll('[data-concierge-open]').forEach((b) => b.addEventListener('click', toggle));

    // desktop has no overlay — close on any click outside the panel (the trigger's own click is excluded)
    document.addEventListener('click', (e) => {
      if (drawer.hidden || isMobileSheet()) return;
      if (e.target.closest('.concierge__panel') || e.target.closest('[data-concierge-open]')) return;
      close();
    });

    // Visibility is decided by what the pill would cover, not by an allow-list somebody has to keep
    // in sync: sample the corners and centre of the box it occupies, take the topmost thing beneath
    // it, and retreat if that is media — a video, an image, or anything painted with a real
    // background image. [data-advisor-deny] still forces a retreat for zones that are not media but
    // should be left clear. (The old [data-advisor-allow] markers this replaced are gone.)
    const trigger = root.querySelector('.concierge__trigger');
    if (trigger && document.elementsFromPoint) {
      // url() only — a gradient is also a backgroundImage, and treating one as media would hide the
      // pill over flat panels that merely fade.
      const isMedia = (el) => el.matches('video, img, picture, svg, canvas, [data-advisor-deny]')
        || /url\(/.test(getComputedStyle(el).backgroundImage);
      const isOpaque = (el) => {
        const c = getComputedStyle(el).backgroundColor;
        if (!c || c === 'transparent') return false;
        const m = c.match(/^rgba?\(([^)]+)\)/);
        if (!m) return false;
        // rgb() has no fourth part and is opaque; rgba() carries the alpha. Read it explicitly —
        // `parseFloat(...) || 1` turns a real alpha of 0 into 1, and the first thing over this
        // corner is a fully transparent utility iframe, so that alone ended every walk at once.
        const parts = m[1].split(',');
        return parts.length < 4 || parseFloat(parts[3]) === 1;
      };

      // Reading only the topmost element called the hero "clear": .hero__cta-wrap is a transparent
      // full-width band that happens to cross this corner, and the video sits under it. So walk the
      // stack the way an eye does — down through anything see-through, stopping at the first opaque
      // surface. Whatever is reached first is what the pill would actually be covering.
      const coversMedia = (x, y) => {
        const stack = document.elementsFromPoint(x, y);
        for (let n = 0; n < stack.length; n++) {
          const el = stack[n];
          if (el === trigger || trigger.contains(el)) continue;
          if (isMedia(el)) return true;
          if (isOpaque(el)) return false;
        }
        return false;
      };

      // getBoundingClientRect follows the 12px retreat transform, and sampling the moved box makes
      // the two states chase each other across a media edge. The used right/bottom never move.
      const restingBox = () => {
        const w = trigger.offsetWidth;
        const h = trigger.offsetHeight;
        if (!w || !h) return null;
        const cs = getComputedStyle(trigger);
        const left = window.innerWidth - (parseFloat(cs.right) || 0) - w;
        const top = window.innerHeight - (parseFloat(cs.bottom) || 0) - h;
        return { left: left, top: top, right: left + w, bottom: top + h };
      };

      // Desktop keeps the pill up the whole way — there is room in that corner and a bubble that
      // comes and goes reads as a glitch on a large screen. The retreat is a small-screen manner,
      // where the pill really does land on top of the content. Checked per frame rather than once,
      // so dragging a window across 1024 picks up the right behaviour immediately.
      const holdsStill = () => window.matchMedia('(min-width: 1024px)').matches;

      let queued = false;
      const check = () => {
        queued = false;
        if (holdsStill()) { document.body.classList.remove('advisor-blocked'); return; }
        if (!drawer.hidden) return; // the panel is open and is itself what sits under the pill
        const r = restingBox();
        if (!r) return;
        const pts = [
          [r.left + 6, r.top + 6], [r.right - 6, r.top + 6],
          [r.left + 6, r.bottom - 6], [r.right - 6, r.bottom - 6],
          [(r.left + r.right) / 2, (r.top + r.bottom) / 2],
        ];
        const blocked = pts.some((p) => coversMedia(p[0], p[1]));
        document.body.classList.toggle('advisor-blocked', blocked);
      };
      const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(check); } };
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule, { passive: true });
      window.addEventListener('load', schedule);  // late images change what is underneath
      schedule();
    }
    root.querySelectorAll('[data-concierge-close]').forEach((b) => b.addEventListener('click', close));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !drawer.hidden) close(); });
  })();

  // WhatsApp context. The drawer is rendered from the layout, so one copy of this link serves every
  // page and Liquid here has no reliable "current product". The colour is worse: the theme swaps
  // variants in place without touching the URL, so even on a product page Liquid could only ever
  // report the default one. Reading the page at the moment of the click settles both. Capture phase,
  // because the browser resolves href only after every listener has run — the rewrite lands in time.
  // A separate IIFE from the drawer above: this must still work on pages where the drawer is absent.
  (function () {
    document.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('a[href*="wa.me/"]');
      if (!link) return;

      var title = document.querySelector('h1.product__title');
      var msg;
      if (title) {
        var swatch = document.querySelector('.product__variant-btn[aria-pressed="true"]');
        var colour = swatch && swatch.title ? ' (' + swatch.title.trim() + ')' : '';
        var variant = document.querySelector('[data-variant-input]');
        msg = "Hi — I'm looking at the " + title.textContent.trim() + colour + ' and have a question.\n'
          + location.origin + location.pathname
          + (variant && variant.value ? '?variant=' + variant.value : '');
      } else {
        msg = 'Hi — I have a question.';
      }
      link.href = link.href.split('?')[0] + '?text=' + encodeURIComponent(msg);
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cookie-banner"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-cookie-banner]');
    if (!root) return;
    var accept = root.querySelector('[data-cookie-accept]');
    var decline = root.querySelector('[data-cookie-decline]');

    function show() {
      root.hidden = false;
      requestAnimationFrame(function () { root.classList.add('is-in'); });
    }
    function hide() {
      root.classList.remove('is-in');
      setTimeout(function () { root.hidden = true; }, 700);
    }

    // The API owns consent state; we only pass the visitor's choice through. All three
    // categories move together here (Accept all vs Necessary only) — no custom storage.
    function record(granted) {
      var api = window.Shopify && window.Shopify.customerPrivacy;
      if (!api || typeof api.setTrackingConsent !== 'function') { hide(); return; }
      api.setTrackingConsent({ analytics: granted, marketing: granted, preferences: granted }, hide);
    }

    function start(api) {
      // shouldShowBanner() is true only where a region requires it AND no choice was made yet;
      // once the visitor picks, it returns false on later loads, so the banner never re-nags.
      if (!api || typeof api.shouldShowBanner !== 'function' || !api.shouldShowBanner()) return;
      show();
      if (accept) accept.addEventListener('click', function () { record(true); });
      if (decline) decline.addEventListener('click', function () { record(false); });
    }

    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
        if (err) return; // API unavailable → stay hidden rather than show a banner that can't record consent
        start(window.Shopify.customerPrivacy);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["craft"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // The atelier film sits below the fold, but an autoplay attribute makes the browser ignore
    // preload="metadata" and pull the whole 1080p rendition the moment the page parses — on a
    // product page that means it races the gallery video for bandwidth before the reader has
    // scrolled anywhere near it. Shipping it without autoplay keeps the initial fetch to a few
    // tens of KB; this starts the real download and playback once it is close to the viewport,
    // the same way details.liquid handles its film.
    var films = document.querySelectorAll('.craft__video video');
    if (!films.length) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    films.forEach(function (video) {
      function play() {
        if (reduceMotion) return;
        var attempt = video.play();
        if (attempt && attempt.catch) attempt.catch(function () {});
      }
      function warm() {
        if (video.preload === 'auto') return;
        video.preload = 'auto';
        video.load();
      }
      if (!('IntersectionObserver' in window)) { warm(); play(); return; }

      // Buffering and playback are split so the film is already downloading by the time it
      // scrolls up. A rootMargin cannot buy that runway here — the block sits under two screens
      // of page, so any margin wide enough to help would already intersect at load — so the
      // first scroll is the trigger instead: someone who bounces off the first screen still
      // fetches nothing, and everyone else gets the whole scroll as head start. Playback stays
      // on a separate observer so it starts at the top of the film, not halfway through.
      window.addEventListener('scroll', warm, { once: true, passive: true });

      var show = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        show.disconnect();
        warm();
        play();
      }, { rootMargin: '0px' });
      show.observe(video);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["details"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[data-video]');
    if (!sections.length) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isDesktop = window.matchMedia('(min-width: 1024px)').matches;

    sections.forEach(function (section) {
      var video = section.querySelector('video');
      if (!video) return;

      var autoplay = section.getAttribute('data-autoplay') === 'true';
      var playOnMobile = section.getAttribute('data-play-mobile') === 'true';

      if (!autoplay || reduceMotion) return;
      if (!isDesktop && !playOnMobile) return;

      function play() {
        var attempt = video.play();
        if (attempt && attempt.catch) {
          attempt.catch(function () {});
        }
      }

      // Without an autoplay attribute the browser holds at preload="metadata", so waiting for
      // the intersection to do everything means arriving at an empty buffer. Buffering starts on
      // the first scroll instead — a visitor who never scrolls still fetches nothing — while
      // playback stays on the observer so the film opens on its first frame.
      function warm() {
        if (video.preload === 'auto') return;
        video.preload = 'auto';
        video.load();
      }

      if (!('IntersectionObserver' in window)) {
        warm();
        play();
        return;
      }

      window.addEventListener('scroll', warm, { once: true, passive: true });

      var observer = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            warm();
            play();
            obs.unobserve(entry.target);
          }
        });
      }, { rootMargin: '200px 0px' });

      observer.observe(video);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    // Subscribe via Klaviyo's client subscription API (built for browser calls, unlike Shopify /contact).
    // No page reload; 202 = real success, anything else = real failure. Submit fires only after native
    // validation (required email) passes.
    var ENDPOINT = 'https://a.klaviyo.com/client/subscriptions';
    var REVISION = '2026-04-15';
    function dismiss(form, s) {
      var email = form.querySelector('input[type="email"]');
      setTimeout(function () {
        s.classList.add('is-dismissing');
        if (email) email.value = '';
        setTimeout(function () { s.style.display = 'none'; s.classList.remove('is-dismissing'); }, 500);
      }, 2500);
    }
    document.querySelectorAll('form[id^="footer-newsletter-"]').forEach(function (form) {
      var key = form.getAttribute('data-klaviyo-key');
      var list = form.getAttribute('data-klaviyo-list');
      if (!key || !list) return;
      var success = form.querySelector('[data-footer-success]');
      var error = form.querySelector('[data-footer-error]');
      var emailEl = form.querySelector('input[type="email"]');
      var button = form.querySelector('[type="submit"]');
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (error) { error.style.display = 'none'; error.textContent = ''; }
        if (button) button.disabled = true;
        function fail() {
          if (button) button.disabled = false;
          if (error) { error.textContent = form.getAttribute('data-error-text') || 'Please try again.'; error.style.display = 'block'; }
        }
        fetch(ENDPOINT + '?company_id=' + encodeURIComponent(key), {
          method: 'POST',
          headers: { 'Content-Type': 'application/vnd.api+json', 'revision': REVISION },
          body: JSON.stringify({ data: { type: 'subscription', attributes: { profile: { data: { type: 'profile', attributes: { email: emailEl ? emailEl.value.trim() : '' } } } }, relationships: { list: { data: { type: 'list', id: list } } } } })
        }).then(function (r) {
          if (r.ok) { if (button) button.disabled = false; if (success) { success.style.display = 'flex'; dismiss(form, success); } }
          else { fail(); }
        }).catch(fail);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    const header = document.querySelector('[data-header]');
    if (!header) return;

    // The bar fills at 10px of scroll everywhere except mobile overlay pages (home hero,
    // product gallery): there it stays transparent until that opening image has scrolled
    // up past the bar, so the header never sits white over the picture.
    const overlayUntil = document.querySelector('[data-overlay-until]');
    const compact = window.matchMedia('(max-width: 1023px)');
    const isOverlay = header.classList.contains('header--overlay');

    const onScroll = () => {
      const scrolled = window.scrollY > 10;
      header.classList.toggle('is-scrolled', scrolled);
      const holdForImage = compact.matches && isOverlay && overlayUntil;
      header.classList.toggle(
        'is-solid',
        holdForImage ? overlayUntil.getBoundingClientRect().bottom <= header.offsetHeight : scrolled
      );
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    const menu = document.querySelector('[data-menu]');
    const openMenu = () => { if (menu) { menu.hidden = false; requestAnimationFrame(() => menu.classList.add('is-open')); document.body.style.overflow = 'hidden'; } };
    const closeMenu = () => { if (menu) { menu.classList.remove('is-open'); document.body.style.overflow = ''; setTimeout(() => { menu.hidden = true; }, 700); } };
    document.querySelectorAll('[data-menu-open]').forEach(b => b.addEventListener('click', openMenu));
    document.querySelectorAll('[data-menu-close]').forEach(b => b.addEventListener('click', closeMenu));

    document.querySelectorAll('[data-menu-toggle]').forEach(btn => {
      btn.addEventListener('click', () => {
        const group = btn.closest('[data-menu-accordion]');
        if (!group) return;
        const open = group.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    const panel = document.querySelector('[data-search-panel]');
    const sInput = panel && panel.querySelector('[data-predictive-input]');
    const sInitial = panel && panel.querySelector('[data-search-initial]');
    const sResults = panel && panel.querySelector('[data-predictive-results]');
    const showInitial = () => {
      if (sResults) { sResults.hidden = true; sResults.innerHTML = ''; }
      if (sInitial) sInitial.hidden = false;
    };
    const toggleSearch = () => {
      if (!panel) return;
      const open = panel.hasAttribute('hidden');
      if (open) {
        panel.hidden = false;
        if (sInput) sInput.value = '';
        showInitial();
        if (sInput) setTimeout(() => sInput.focus(), 50);
      } else {
        panel.hidden = true;
      }
    };
    document.querySelectorAll('[data-search-toggle]').forEach(b => b.addEventListener('click', toggleSearch));

    // Signed-in marks. The bar ships signed-out (see the account link's comment) so the client
    // paints them: the initial replaces the account glyph, and Log out joins the drawer. The name
    // is whatever the account page cached; if a session predates that cache, ask for it once.
    (function () {
      var avatar = document.querySelector('[data-account-avatar]');
      var glyph = document.querySelector('[data-account-icon]');
      var logout = document.querySelector('[data-caa-logout]');
      if (!avatar && !logout) return;

      function cachedName() {
        try { return localStorage.getItem('caa_name') || ''; } catch (e) { return ''; }
      }
      // First letter or digit — punctuation and spaces are not an identity. Nothing usable in the
      // name at all keeps the glyph rather than showing an empty ring.
      function initialOf(name) {
        var m = String(name || '').match(/[\p{L}\p{N}]/u);
        return m ? m[0].toUpperCase() : '';
      }
      function paint() {
        var C = window.ARFORTI_CAA;
        var signedIn = !!(C && C.isLoggedIn());
        if (logout) logout.hidden = !signedIn;
        if (!avatar || !glyph) return;
        var initial = signedIn ? initialOf(cachedName()) : '';
        avatar.textContent = initial;
        avatar.hidden = !initial;
        glyph.style.display = initial ? 'none' : '';
        return signedIn && !initial;
      }
      function start() {
        if (!paint()) return;
        var C = window.ARFORTI_CAA;
        C.query('query HeaderName { customer { firstName lastName emailAddress { emailAddress } } }')
          .then(function (r) {
            var c = r && r.data && r.data.customer;
            if (!c) return;
            // first field that yields a usable character, so a name of only punctuation falls
            // through to the surname or the address instead of blanking the ring
            var name = [c.firstName, c.lastName, c.emailAddress && c.emailAddress.emailAddress]
              .filter(function (v) { return initialOf(v); })[0];
            if (!name) return;
            try { localStorage.setItem('caa_name', name); } catch (e) {}
            paint();
          })
          .catch(function () {});
      }

      if (logout) logout.addEventListener('click', function () {
        try { localStorage.removeItem('caa_name'); } catch (e) {}
        if (window.ARFORTI_CAA) window.ARFORTI_CAA.logout();
      });
      if (window.ARFORTI_CAA) start();
      else document.addEventListener('caa:ready', start, { once: true });
    })();

    // Site-wide waitlist status: fills every count in the header (desktop nav + drawer),
    // reveals the ON THE LIST badge only when the list has items (ring goes solid when
    // something is back in stock), and lights the burger dot while a waited-on variant is
    // available. Logged-in only (CAA metafield), cached 10 minutes.
    (function () {
      var counts = document.querySelectorAll('.header [data-waitlist-count], .header__menu [data-waitlist-count]'); /* the drawer sits outside <header> */
      var badge = document.querySelector('.header__menu-waitlist-badge');
      var burger = document.querySelector('.header__burger');
      if (!counts.length && !badge && !burger) return;
      var KEY = 'caa_wl_state', TTL = 10 * 60 * 1000;
      function render(n, ready) {
        counts.forEach(function (c) { c.textContent = n; });
        if (badge) {
          badge.hidden = !(n > 0);
          badge.classList.toggle('is-ready', ready > 0);
          badge.textContent = ready > 0 ? (badge.getAttribute('data-label-ready') || 'In Stock') : badge.getAttribute('data-label');
        }
        if (burger) burger.classList.toggle('has-wl-ready', ready > 0);
      }
      function save(n, ready) {
        try { localStorage.setItem(KEY, JSON.stringify({ t: Date.now(), n: n, r: ready })); } catch (e) {}
      }
      function sync() {
        var C = window.ARFORTI_CAA;
        if (!C || !C.isLoggedIn()) { try { localStorage.removeItem(KEY); } catch (e) {} render(0, 0); return; }
        C.query('query { customer { metafield(namespace: "custom", key: "waitlist") { value } } }').then(function (r) {
          var val = r && r.data && r.data.customer && r.data.customer.metafield && r.data.customer.metafield.value;
          var entries = [];
          try { entries = JSON.parse(val || '[]') || []; } catch (e) {}
          if (!entries.length) { save(0, 0); render(0, 0); return; }
          var handles = entries.map(function (e) { return String(e).split(':')[0]; });
          var uniq = handles.filter(function (h, i) { return handles.indexOf(h) === i; });
          Promise.all(uniq.map(function (h) {
            return fetch('/products/' + h + '?view=wl')
              .then(function (res) { return res.ok ? res.json() : null; })
              .catch(function () { return null; });
          })).then(function (prods) {
            var byHandle = {};
            prods.forEach(function (p) { if (p) byHandle[p.handle] = p; });
            var ready = entries.filter(function (e) {
              var parts = String(e).split(':');
              var p = byHandle[parts[0]];
              if (!p || !p.variants) return false;
              for (var i = 0; i < p.variants.length; i++) {
                if (String(p.variants[i].id) === parts[1]) return !!p.variants[i].available;
              }
              return false;
            }).length;
            save(entries.length, ready);
            render(entries.length, ready);
          });
        }).catch(function () {});
      }
      // ?wlstate=waiting|ready|off — design/QA preview of the three states, no login needed
      var demo = /[?&]wlstate=(ready|waiting|off)/.exec(location.search);
      if (demo) { render(demo[1] === 'off' ? 0 : 2, demo[1] === 'ready' ? 1 : 0); return; }
      var cached = null;
      try { cached = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) {}
      if (cached) render(cached.n, cached.r); // paint instantly from cache
      if (cached && Date.now() - cached.t < TTL) return; // fresh enough, skip the network
      if (window.ARFORTI_CAA) sync();
      else document.addEventListener('caa:ready', sync, { once: true });
    })();

    // this store's /search ignores the documented prefix params; a trailing * on the last term is
    // what partial-matches (measured: ALI→0, ALI*→1). The star rides a hidden field so the visible
    // input never shows it.
    const sForm = panel && panel.querySelector('.header__search-form');
    if (sForm && sInput) sForm.addEventListener('submit', () => {
      const v = sInput.value.trim();
      if (!v || /["*]$/.test(v)) return;
      let starred = sForm.querySelector('[data-q-starred]');
      if (!starred) {
        starred = document.createElement('input');
        starred.type = 'hidden';
        starred.setAttribute('data-q-starred', '');
        sForm.appendChild(starred);
      }
      starred.name = 'q';
      starred.value = v + '*';
      sInput.name = ''; // the visible input drops out of the submission
    });

    if (sInput && sResults) {
      const purl = panel.getAttribute('data-predictive-url') || '/search/suggest';
      let timer; let ctrl;
      const run = async (q) => {
        if (ctrl) ctrl.abort();
        if (!q.trim()) { showInitial(); return; }
        ctrl = new AbortController();
        try {
          const url = purl + '?q=' + encodeURIComponent(q) + '&section_id=predictive-search&resources[type]=product&resources[limit]=4';
          const res = await fetch(url, { signal: ctrl.signal });
          if (!res.ok) return;
          sResults.innerHTML = await res.text();
          if (sInitial) sInitial.hidden = true;
          sResults.hidden = false;
        } catch (e) {
          /* aborted or network error */
        }
      };
      sInput.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(() => run(sInput.value), 250); });
    }

    const region = document.querySelector('[data-region]');
    let closeRegion = () => {};
    if (region) {
      const localeInput = region.querySelector('[data-locale-input]');
      const countryInput = region.querySelector('[data-country-input]');
      const dests = region.querySelectorAll('[data-locale]');
      const curs = region.querySelectorAll('[data-country]');
      const openRegion = () => { region.hidden = false; requestAnimationFrame(() => region.classList.add('is-open')); document.body.style.overflow = 'hidden'; };
      closeRegion = () => { region.classList.remove('is-open'); document.body.style.overflow = ''; setTimeout(() => { region.hidden = true; }, 500); };
      document.querySelectorAll('[data-region-open]').forEach(b => b.addEventListener('click', () => { if (menu && !menu.hidden) closeMenu(); openRegion(); }));
      region.querySelectorAll('[data-region-close]').forEach(b => b.addEventListener('click', closeRegion));
      dests.forEach(d => d.addEventListener('click', () => {
        if (localeInput) localeInput.value = d.dataset.locale;
        dests.forEach(x => x.classList.toggle('is-active', x === d));
      }));
      curs.forEach(c => c.addEventListener('click', () => {
        if (countryInput) countryInput.value = c.dataset.country;
        curs.forEach(x => x.classList.toggle('is-active', x === c));
      }));
    }

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        if (menu && !menu.hidden) closeMenu();
        if (panel && !panel.hasAttribute('hidden')) panel.hidden = true;
        if (region && !region.hidden) closeRegion();
      }
    });
  })();
  // Mobile menu social links mirror the footer. The merchant edits one place — the footer blocks in
  // the theme editor — and this row follows. Liquid could not do it: a section cannot read another
  // section's blocks. But the footer is in the DOM on every page, so reading it at runtime is the
  // one path that works. Only the addresses are copied; the short forms below stay a mobile concern,
  // and anything unrecognised keeps the footer's own wording rather than being dropped.
  (function () {
    var SHORT = { facebook: 'FB', instagram: 'IG', tiktok: 'TT', pinterest: 'PIN', youtube: 'YT', twitter: 'X', 'x.com': 'X' };
    function mirror() {
      var box = document.querySelector('[data-social-mirror]');
      var links = document.querySelectorAll('.footer__social-link');
      if (!box || !links.length) return;   // no footer links → leave the server-rendered fallback alone
      box.textContent = '';
      Array.prototype.forEach.call(links, function (src) {
        var host = '';
        try { host = new URL(src.href, location.origin).hostname.replace(/^www./, ''); } catch (e) {}
        var key = Object.keys(SHORT).filter(function (k) { return host.indexOf(k) >= 0; })[0];
        var a = document.createElement('a');
        a.className = 'header__menu-social-link ts-sm-xs';
        a.href = src.getAttribute('href');
        a.textContent = key ? SHORT[key] : src.textContent.trim();
        box.appendChild(a);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mirror);
    else mirror();
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // The autoplay attribute is the primary path and needs nothing from here. It only falls
    // short on a link slower than the file's bitrate: Chrome holds playback until it believes
    // the video can run through without stalling, so a 7.2Mbps rendition on a 4Mbps connection
    // sat at HAVE_FUTURE_DATA — playable — for sixteen seconds while it banked 8.8s of buffer.
    // An explicit play() is not bound by that judgement and starts on the first frame it has,
    // which is what the old script-driven hero did (2.7s on the same link). This is only an
    // accelerant: if it arrives late, or never, autoplay still fires on its own.
    document.querySelectorAll('.hero__video[autoplay]').forEach(function (video) {
      function kick() {
        if (!video.paused) return;
        var attempt = video.play();
        if (attempt && attempt.catch) attempt.catch(function () {});
      }
      if (video.readyState >= 2) kick();
      else video.addEventListener('loadeddata', kick, { once: true });

      // Last resort, and the reason it exists: if the browser never settles on a <source>, no media
      // event ever fires, readyState stays at 0 and the kick above is never reached — the hero just
      // sits on its poster with nothing in the console to explain it. Assigning src directly skips
      // source selection entirely. Harmless when selection worked, since this returns early then.
      // Deliberately the mp4 and not the first source: the first is now the HLS playlist, and the
      // only browsers that reach this line are the ones that settled on nothing, which includes
      // every browser that cannot play HLS. Forcing the playlist on those would guarantee the
      // failure this is here to rescue. The mp4 plays everywhere.
      setTimeout(function () {
        if (video.currentSrc || video.readyState > 0) return;
        var mp4 = video.querySelector('source[type="video/mp4"]') || video.querySelector('source');
        if (!mp4 || !mp4.getAttribute('src')) return;
        video.src = mp4.getAttribute('src');
        video.load();
        kick();
      }, 2500);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Subscribe via Klaviyo's client subscription API (built for browser calls, CORS-open, unlike
    // Shopify /contact). No page reload; 202 = real success, anything else = real failure. The submit
    // event only fires after native validation (required email + consent) passes.
    var ENDPOINT = 'https://a.klaviyo.com/client/subscriptions';
    var REVISION = '2026-04-15';
    function dismiss(form, s) {
      var email = form.querySelector('input[type="email"]');
      setTimeout(function () {
        s.classList.add('is-dismissing');
        if (email) email.value = '';
        setTimeout(function () { s.style.display = 'none'; s.classList.remove('is-dismissing'); }, 500);
      }, 2500);
    }
    document.querySelectorAll('form[id^="newsletter-"]').forEach(function (form) {
      var key = form.getAttribute('data-klaviyo-key');
      var list = form.getAttribute('data-klaviyo-list');
      if (!key || !list) return;
      var success = form.querySelector('[data-nl-success]');
      var error = form.querySelector('[data-nl-error]');
      var emailEl = form.querySelector('input[type="email"]');
      var button = form.querySelector('[type="submit"]');
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (error) { error.style.display = 'none'; error.textContent = ''; }
        if (button) button.disabled = true;
        function fail() {
          if (button) button.disabled = false;
          if (error) { error.textContent = form.getAttribute('data-error-text') || 'Please try again.'; error.style.display = 'block'; }
        }
        fetch(ENDPOINT + '?company_id=' + encodeURIComponent(key), {
          method: 'POST',
          headers: { 'Content-Type': 'application/vnd.api+json', 'revision': REVISION },
          body: JSON.stringify({ data: { type: 'subscription', attributes: { profile: { data: { type: 'profile', attributes: { email: emailEl ? emailEl.value.trim() : '' } } } }, relationships: { list: { data: { type: 'list', id: list } } } } })
        }).then(function (r) {
          if (r.ok) { if (button) button.disabled = false; if (success) { success.style.display = 'flex'; dismiss(form, success); } }
          else { fail(); }
        }).catch(fail);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-product]');
    if (!root) return;

    var gallery = root.querySelector('[data-product-gallery]');
    var pmob = root.querySelector('[data-progress-mobile]');
    var ppc = root.querySelector('[data-progress-pc]');

    function updateProgress() {
      if (!gallery) return;
      if (window.matchMedia('(min-width: 1024px)').matches) {
        var maxY = gallery.scrollHeight - gallery.clientHeight;
        if (ppc) ppc.style.height = (maxY > 0 ? (gallery.scrollTop / maxY) * 100 : 0) + '%';
      } else {
        var maxX = gallery.scrollWidth - gallery.clientWidth;
        if (pmob) pmob.style.width = (maxX > 0 ? (gallery.scrollLeft / maxX) * 100 : 0) + '%';
      }
    }

    if (gallery) {
      gallery.addEventListener('scroll', updateProgress, { passive: true });
      window.addEventListener('resize', updateProgress);
      updateProgress();
    }

    // ---------- Warm the gallery video before the reader reaches it ----------
    // Shopify serves one 1080p rendition and video_tag ships preload="metadata", so a video
    // sitting at the end of the gallery starts downloading from zero at the moment it is
    // scrolled into view. Watching its slide with a root margin three slides deep flips it to
    // preload="auto" early enough that playback starts on arrival; a reader who never scrolls
    // that far still downloads nothing. Each slide is 100% of the gallery in both orientations,
    // so one margin covers desktop's vertical scroll and mobile's horizontal one.
    if (gallery && 'IntersectionObserver' in window) {
      gallery.querySelectorAll('video').forEach(function (vid) {
        var slide = vid.closest('.product__slide');
        if (!slide) return;
        var io = new IntersectionObserver(function (entries) {
          if (!entries[0].isIntersecting) return;
          io.disconnect();
          vid.preload = 'auto';
          vid.load();
        }, { root: gallery, rootMargin: '300%' });
        io.observe(slide);
      });
    }

    // ---------- Fullscreen image viewer ----------
    // The stills are one scrolling column: stacked at full width, edge to edge, inside a real
    // scroll container. The browser does the scrolling, so there is no end of one still to stop
    // at before the next begins, and momentum, rubber banding and the clamps come free.
    (function () {
      var box = document.querySelector('[data-lightbox]');
      if (!box || !box.showModal) return;

      var stage = box.querySelector('[data-lightbox-stage]');
      var slides = [].slice.call(box.querySelectorAll('.lightbox__img'));
      var thumbs = [].slice.call(box.querySelectorAll('[data-lightbox-thumb]'));
      var closeBtn = box.querySelector('[data-lightbox-close]');

      var rail = box.querySelector('[data-lightbox-rail]');
      if (!stage || !rail || !slides.length) return;
      var railTimer = 0;
      var closedAt = 0; // when the lightbox last closed, so its own dismiss click cannot reopen it
      var railZoomed = false; // tracks the rail's zoomed/not state so it only flips once per crossing

      var MAX = 4;
      var idx = 0;
      var zoom = 1;
      var opener = null;
      var calm = window.matchMedia('(prefers-reduced-motion: reduce)');

      // A closed dialog never triggers a lazy load, so the first frame would otherwise be empty.
      // Flipping the attribute starts the fetch; do it for the still in play and the two either
      // side, and never on page load — someone who never opens this pays nothing for it.
      function warm(i) {
        for (var n = i - 1; n <= i + 1; n++) {
          if (slides[n] && slides[n].loading === 'lazy') slides[n].loading = 'eager';
        }
      }

      // The rail comes out while the column is moving and goes away again, the way a scrollbar
      // does — and stays away while zoomed in, where it would sit on the detail being examined.
      function reveal(hold) {
        window.clearTimeout(railTimer);
        if (zoom > 1.01) {
          rail.classList.remove('is-shown');
          return;
        }
        rail.classList.add('is-shown');
        railTimer = window.setTimeout(function () {
          rail.classList.remove('is-shown');
        }, hold || 1100);
      }

      function markThumb(i) {
        thumbs.forEach(function (t, n) {
          t.classList.toggle('is-on', n === i);
          if (n === i && t.scrollIntoView) t.scrollIntoView({ block: 'nearest' });
        });
      }

      function show(i, ms) {
        if (i < 0 || i > slides.length - 1) return;
        warm(i);
        idx = i;
        markThumb(i);
        stage.scrollTo({
          top: slides[i].offsetTop,
          behavior: ms && !calm.matches ? 'smooth' : 'auto'
        });
      }

      // Which still the column is actually showing — the one under the middle of the screen.
      function readScroll() {
        var mid = stage.scrollTop + stage.clientHeight / 2;
        var n = 0;
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].offsetTop <= mid) n = i;
        }
        /* Scroll offsets written by a pinch or a one-finger pan are our own, not the reader
           scrolling the column — treating them as scrolling re-armed the rail every frame and
           made it blink through the gesture. */
        if (!pinch && !pan) reveal();
        if (n === idx) return;
        idx = n;
        markThumb(n);
        warm(n);
      }

      // Zoom widens the column and the same scroller pans it, so the scroll offsets are nudged
      // to hold the pixel under the fingers still. `box` is the stage's rect, which the caller
      // supplies during a gesture — reading it here would force a fresh layout on every frame,
      // right after the width change had just invalidated one.
      /* Takes the content sitting under (fromX, fromY) and leaves it under (px, py) at the new
         scale. Wheel zoom passes one point and it stays an anchor; a pinch passes the midpoint
         where the fingers were and where they are now, so the scale and the drag resolve in a
         single write. Doing them as two steps — anchor at the new midpoint, then translate by
         the midpoint delta — counts that delta twice, which is what made a two-finger drag
         slide away from the fingers. */
      function zoomAt(next, px, py, box, fromX, fromY) {
        var to = Math.max(1, Math.min(MAX, next));
        var ax = fromX === undefined ? px : fromX;
        var ay = fromY === undefined ? py : fromY;
        if (Math.abs(to - zoom) < 0.001 && ax === px && ay === py) return;
        var r = box || stage.getBoundingClientRect();
        var cx = (ax - r.left + stage.scrollLeft) / zoom;
        var cy = (ay - r.top + stage.scrollTop) / zoom;
        zoom = to;
        stage.style.setProperty('--lb-zoom', to);
        stage.scrollLeft = cx * to - (px - r.left);
        stage.scrollTop = cy * to - (py - r.top);
        /* Only act when the picture actually crosses in or out of "zoomed". Firing on every
           call meant a pinch settling near 1x toggled the rail on and off frame after frame,
           which is the flicker on the way back down. */
        var nowZoomed = zoom > 1.01;
        if (nowZoomed !== railZoomed) {
          railZoomed = nowZoomed;
          if (nowZoomed) {
            window.clearTimeout(railTimer);
            rail.classList.remove('is-shown');
          } else {
            reveal();
          }
        }
      }

      // The column flies out of the slide that was tapped, then settles into the stage.
      // A modal dialog does not cover the page's own scrollbar — measured 1436 of dialog inside a
      // 1440 viewport — so a strip of the page behind shows down the right edge. Take the
      // scrollbar away for the duration and hand its width back as padding, or the page behind
      // shifts by that much and lurches when it returns.
      function holdPage(on) {
        var el = document.documentElement;
        if (on) {
          var bar = window.innerWidth - el.clientWidth;
          el.style.overflow = 'hidden';
          if (bar > 0) el.style.paddingRight = bar + 'px';
        } else {
          el.style.overflow = '';
          el.style.paddingRight = '';
        }
      }

      function open(from, i) {
        pinch = null;
        pan = null;
        railZoomed = false;
        tapFrom = null;
        holdPage(true);
        opener = from;
        zoom = 1;
        stage.style.setProperty('--lb-zoom', 1);
        box.showModal();
        // autofocus on a dialog is read differently by different engines; say it outright. With
        // focus on the dialog no control inside is focused, so nothing is ringed on opening, and
        // Tab still reaches the thumbnails and the close.
        box.focus();
        idx = Math.max(0, Math.min(slides.length - 1, i));
        warm(idx);
        markThumb(idx);
        stage.scrollLeft = 0;
        stage.scrollTop = slides[idx].offsetTop;
        reveal(1600);
      }

      // Closing is not an animation. It ran the flight home in reverse over 300ms, which meant
      // the picture was still on screen long after the tap that dismissed it.
      function shut() {
        /* Stamped here, not in the close handler: dialog.close() fires its event on a queued task,
           and the click that follows the dismissing tap arrives ~3ms later — before that task runs. */
        closedAt = Date.now();
        opener = null;
        box.close();
      }

      // Touching a slide is the earliest honest signal that it is about to be opened, which buys
      // the fetch a head start on the flight in.
      root.addEventListener(
        'pointerdown',
        function (e) {
          var slide = e.target.closest ? e.target.closest('[data-lb-open]') : null;
          if (slide) warm(parseInt(slide.getAttribute('data-lb-open'), 10) || 0);
        },
        { passive: true }
      );

      root.addEventListener('click', function (e) {
        /* The tap that dismisses the lightbox becomes a click AFTER the dialog has already left the
           top layer, so the browser hit-tests it against the gallery underneath — a slide — and this
           handler reopened the thing the tap had just closed. It read as the tap doing nothing, with
           a frame of close-then-open in between. Ignore the click that belongs to that same gesture. */
        if (Date.now() - closedAt < 500) return;
        var slide = e.target.closest ? e.target.closest('[data-lb-open]') : null;
        if (!slide) return;
        var img = slide.querySelector('img');
        open(img || slide, parseInt(slide.getAttribute('data-lb-open'), 10) || 0);
      });

      thumbs.forEach(function (t, n) {
        t.addEventListener('click', function () {
          show(n, 260);
        });
      });

      if (closeBtn) closeBtn.addEventListener('click', shut);

      // Reaching for the rail with a mouse has to be enough to bring it back — a pointer that far
      // right is on its way there and nowhere else.
      box.addEventListener('pointermove', function (e) {
        if (e.pointerType !== 'mouse') return;
        if (e.clientX > window.innerWidth - 150) reveal();
      });

      rail.addEventListener('pointerenter', function () {
        reveal(2400);
      });

      box.addEventListener('close', function () {
        /* Collapse the picture back to 1x BEFORE handing the page its scrolling back. Left zoomed,
           the stage is still several thousand pixels of scroll content, and restoring the document's
           overflow forces that whole thing through layout in the same frame — which is the stutter
           and flash on dismissing a zoomed image. Clearing pan/zoom here also stops the next open
           from starting on the previous gesture's coordinates. */
        zoom = 1;
        stage.style.setProperty('--lb-zoom', 1);
        stage.scrollLeft = 0;
        pan = null;
        railZoomed = false;
        holdPage(false);
        window.clearTimeout(railTimer);
        rail.classList.remove('is-shown');
        pinch = null;
        tapFrom = null;
        stage.style.transition = '';
        stage.style.transform = '';
        stage.style.transformOrigin = '';
        box.style.transition = '';
        box.style.opacity = '';
        closedAt = Date.now();
        if (opener && opener.focus) opener.focus();
        opener = null;
      });

      // Esc reaches the dialog as a cancel; run it through the same flight home.
      box.addEventListener('cancel', function (e) {
        e.preventDefault();
        shut();
      });

      box.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') show(Math.min(slides.length - 1, idx + 1), 260);
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') show(Math.max(0, idx - 1), 260);
      });

      stage.addEventListener('scroll', readScroll, { passive: true });

      window.addEventListener('resize', function () {
        if (!box.open) return;
        stage.scrollTop = slides[idx].offsetTop;
      });

      var touchedAt = 0;

      // A tap on the picture dismisses, immediately. Zoom is the pinch — and ctrl+wheel for a
      // mouse — so there is no second tap to wait for and no reason to make the close hesitate.
      // Zoomed in a tap does nothing: you are reading detail, and the way out is the pinch or
      // the X.
      /* Two stages, the way a photo viewer behaves: zoomed in, a tap on the picture pulls back
         to 1x instead of dismissing — you are still reading it. The next tap closes. Doing nothing
         at all (what this used to do) reads as the tap having been swallowed. */
      function tapped() {
        if (zoom > 1.01) {
          var r = stage.getBoundingClientRect();
          zoomAt(1, r.left + r.width / 2, r.top + r.height / 2, r);
          return;
        }
        shut();
      }

      stage.addEventListener('click', function (e) {
        var since = Date.now() - touchedAt;
        if (since < 700) return;
        tapped();
      });

      stage.addEventListener(
        'wheel',
        function (e) {
          // a trackpad pinch arrives as ctrl+wheel; a plain wheel is the column's own scrolling
          if (!e.ctrlKey) return;
          e.preventDefault();
          zoomAt(zoom * (1 - e.deltaY / 200), e.clientX, e.clientY);
        },
        { passive: false }
      );

      // One finger scrolls the column, which is the browser's job. Two are ours.
      //
      // touch-action is latched when a gesture begins, so raising it to `none` on the second
      // finger — which is what this did before — changes nothing for the gesture already under
      // way: the browser went on scrolling while the pinch resized underneath it, which is why
      // pinching felt like it was fighting something. Cancelling the default on the touchstart
      // that brings the second finger down does stop it, and that has to be a touch listener,
      // registered non-passive, because a pointer event cannot cancel scrolling.
      var pinch = null;
      var pan = null; // one-finger drag while zoomed in
      var tapFrom = null;

      function spread(t) {
        var dx = t[0].clientX - t[1].clientX;
        var dy = t[0].clientY - t[1].clientY;
        return { d: Math.hypot(dx, dy), x: (t[0].clientX + t[1].clientX) / 2, y: (t[0].clientY + t[1].clientY) / 2 };
      }

      stage.addEventListener(
        'touchstart',
        function (e) {
          touchedAt = Date.now();
          if (e.touches.length === 1) {
            tapFrom = { x: e.touches[0].clientX, y: e.touches[0].clientY };
            // Zoomed in, one finger has to drag the picture 1:1. Left to the native scroller it
            // gets a fling: a 160px drag measured 268px of extra travel after the finger left,
            // which is no way to read detail. Cancelling the default here stops that scroll from
            // ever starting, so the frames below are the only thing moving the image.
            pan = zoom > 1.01 ? { x: e.touches[0].clientX, y: e.touches[0].clientY } : null;
            if (pan) e.preventDefault();
            return;
          }
          pan = null;
          if (e.touches.length !== 2) return;
          e.preventDefault();
          tapFrom = null;
          var s = spread(e.touches);
          // one read for the whole gesture; every frame after this only writes
          pinch = { d: s.d, z: zoom, x: s.x, y: s.y, box: stage.getBoundingClientRect(), frame: 0 };
        },
        { passive: false }
      );

      stage.addEventListener(
        'touchmove',
        function (e) {
          if (pan && e.touches.length === 1) {
            e.preventDefault();
            var t = e.touches[0];
            stage.scrollLeft -= t.clientX - pan.x;
            stage.scrollTop -= t.clientY - pan.y;
            pan.x = t.clientX;
            pan.y = t.clientY;
            return;
          }
          if (!pinch || e.touches.length !== 2) return;
          e.preventDefault();
          // A high-refresh screen delivers two or three of these per frame, and each one used to
          // write the width, read the geometry back — forcing the layout it had just invalidated
          // — and then write the scroll. Record the fingers and settle up once a frame instead.
          pinch.at = spread(e.touches);
          if (pinch.frame) return;
          pinch.frame = requestAnimationFrame(function () {
            if (!pinch) return;
            var s = pinch.at;
            pinch.frame = 0;
            // Scale is measured against the spread the gesture started with, so it never drifts
            // frame to frame; the translation rides along in the same call.
            var k = s.d > 0 && pinch.d > 0 ? s.d / pinch.d : 1;
            zoomAt(pinch.z * k, s.x, s.y, pinch.box, pinch.x, pinch.y);
            pinch.x = s.x;
            pinch.y = s.y;
          });
        },
        { passive: false }
      );

      stage.addEventListener('touchend', function (e) {
        touchedAt = Date.now();
        if (e.touches.length < 2) {
          if (pinch && pinch.frame) cancelAnimationFrame(pinch.frame);
          pinch = null;
        }
        if (!e.touches.length) pan = null;

        // A tap that scrolled is not a tap, and neither is the end of a pinch.
        if (e.touches.length || !tapFrom) {
          return;
        }
        var t = e.changedTouches[0];
        if (!t) return;
        var moved = Math.hypot(t.clientX - tapFrom.x, t.clientY - tapFrom.y);
        tapFrom = null;
        if (moved > 8) return;
        tapped();
      });

      stage.addEventListener('touchcancel', function () {
        if (pinch && pinch.frame) cancelAnimationFrame(pinch.frame);
        pinch = null;
        pan = null;
        tapFrom = null;
      });
    })();

    var priceEl = root.querySelector('[data-product-price]');
    var variantInput = root.querySelector('[data-variant-input]');
    var addBtn = root.querySelector('[data-add-btn]');
    var waitBtn = root.querySelector('[data-waitlist-btn]');
    var dynamicCheckout = root.querySelector('[data-dynamic-checkout]');
    /* The colour row borrows .product__variants for layout only. Left in this list it was
       treated as a variant group: its links carry no data-variant-id, so clicking one made
       selectVariant compare null against null and mark every colourway as selected. */
    var groups = root.querySelectorAll('.product__variants:not(.product__variants--colors)');

    // The cart drawer intercepts this form's submit, adds over AJAX and reports back. Carry the
    // button through that wait: spinner while it is in flight, a brief settled label on success,
    // straight back to normal on failure so the reason the drawer shows is not competing with a
    // stuck button. The sticky bar submits this same form, so it is covered too.
    var addedTimer;
    var addForm = root.querySelector('.product__form');
    if (addForm && addBtn) {
      // Both buttons submit this one form, so both carry the state. Putting it on addBtn alone
      // animated the button that had just scrolled away — the sticky bar only exists BECAUSE the
      // CTA is off screen, so a tap down there produced no visible feedback at all.
      var feedbackBtns = function () {
        var list = [addBtn];
        var sb = root.querySelector('[data-sticky-add]');
        if (sb) list.push(sb);
        return list;
      };
      addForm.addEventListener('submit', function () {
        if (addBtn.disabled) return;
        clearTimeout(addedTimer);
        feedbackBtns().forEach(function (b) {
          b.classList.remove('is-added');
          b.classList.add('is-adding');
        });
      });
      document.addEventListener('arforti:cart-added', function (e) {
        var live = feedbackBtns().filter(function (b) { return b.classList.contains('is-adding'); });
        if (!live.length) return;
        live.forEach(function (b) { b.classList.remove('is-adding'); });
        if (!(e.detail && e.detail.ok)) return;
        live.forEach(function (b) { b.classList.add('is-added'); });
        addedTimer = setTimeout(function () {
          live.forEach(function (b) { b.classList.remove('is-added'); });
        }, 1400);
      });
    }

    function selectVariant(id, price, available) {
      groups.forEach(function (g) {
        g.querySelectorAll('.product__variant-btn').forEach(function (b) {
          b.setAttribute('aria-pressed', b.getAttribute('data-variant-id') === id ? 'true' : 'false');
        });
      });
      if (variantInput) variantInput.value = id;
      if (priceEl && price) priceEl.textContent = price;
      if (addBtn) {
        addBtn.disabled = !available;
        addBtn.textContent = available ? addBtn.getAttribute('data-label') : addBtn.getAttribute('data-soldout');
      }
      if (dynamicCheckout) dynamicCheckout.hidden = !available;
      if (waitBtn) waitBtn.hidden = available;
      if (stickyBtn) stickyBtn.textContent = available ? stickyBtn.getAttribute('data-label') : stickyBtn.getAttribute('data-soldout');
    }

    groups.forEach(function (g) {
      g.addEventListener('click', function (e) {
        var btn = e.target.closest('.product__variant-btn');
        if (!btn) return;
        selectVariant(
          btn.getAttribute('data-variant-id'),
          btn.getAttribute('data-variant-price'),
          btn.getAttribute('data-variant-available') === 'true'
        );
      });
    });

    if (waitBtn) {
      waitBtn.addEventListener('click', function () {
        document.dispatchEvent(new CustomEvent('arforti:waitlist-open', {
          detail: { id: variantInput ? variantInput.value : null }
        }));
      });
    }

    // Mobile sticky ATC (source stickyAddBar + Demellier manners): show once the CTA scrolls above
    // the viewport, retire when the footer arrives; the advisor bubble yields via body.atc-bar-shown.
    var stickyBar = root.querySelector('[data-sticky-bar]');
    var stickyBtn = root.querySelector('[data-sticky-add]');
    var ctaArea = root.querySelector('[data-product-cta]');
    var footerEl = document.querySelector('.footer');
    function updateStickyBar() {
      if (!stickyBar || !ctaArea) return;
      var ctaOut = ctaArea.getBoundingClientRect().bottom < 0;
      var footerIn = footerEl ? footerEl.getBoundingClientRect().top < window.innerHeight : false;
      // 1024, matching the CSS that retires this bar and the store's single breakpoint — at 768 the
      // stylesheet let the bar through on tablet while this line held it back, so an iPad reading
      // the details had no way to buy without scrolling all the way up again.
      var show = window.innerWidth < 1024 && ctaOut && !footerIn;
      stickyBar.classList.toggle('is-shown', show);
      stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true');
      document.body.classList.toggle('atc-bar-shown', show);
    }
    window.addEventListener('scroll', updateStickyBar, { passive: true });
    window.addEventListener('resize', updateStickyBar, { passive: true });
    updateStickyBar();

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var available = addBtn && !addBtn.disabled;
        if (available) {
          var form = root.querySelector('.product__form');
          if (form) form.requestSubmit(); // the cart drawer intercepts the submit (AJAX add + open)
        } else {
          document.dispatchEvent(new CustomEvent('arforti:waitlist-open', {
            detail: { id: variantInput ? variantInput.value : null }
          }));
        }
      });
    }

    root.querySelectorAll('[data-accordion-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var content = btn.nextElementSibling;
        if (!content) return;
        var open = content.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    // Shop Pay clicks are invisible to Meta's event setup tool, so they never produce an
    // InitiateCheckout. The button is <shop-pay-wallet-button> with a CLOSED shadow root — the
    // tool builds CSS selectors from inspectable DOM and there is nothing in there to select,
    // which is why every other button on this page can be picked and this one cannot. A closed
    // root hides its contents but does not stop events: measured, a real click surfaces here as
    // an ordinary bubbled click. So rather than pointing at the button, we wait for it.
    //
    // Purely an observer. No preventDefault, no stopPropagation, and the whole body is wrapped so
    // a throw cannot escape. If Shopify renames the element the selector simply stops matching
    // and the click proceeds untouched — the failure mode is missing data, never a blocked
    // checkout. Publishing to Shopify's own event stream rather than calling a pixel directly
    // keeps this file free of any vendor: whatever consumes it is configured in the admin.
    var wallet = root.querySelector('[data-dynamic-checkout]');
    if (wallet) {
      var lastSent = 0;
      wallet.addEventListener('click', function () {
        try {
          var now = Date.now();
          if (now - lastSent < 1500) return;   // one impatient double-click is still one intent
          lastSent = now;

          var variantInput = root.querySelector('[data-variant-input]');
          var priceEl = root.querySelector('[data-product-price]');
          var amount = priceEl ? parseFloat(String(priceEl.textContent).replace(/[^0-9.]/g, '')) : null;

          if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
            Shopify.analytics.publish('arforti_accelerated_checkout', {
              variant_id: variantInput ? variantInput.value : null,
              value: isNaN(amount) ? null : amount,
              currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || null
            });
          }
        } catch (e) { /* never let instrumentation touch the checkout path */ }
      });
    }
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-reviews]');
    if (!root) return;

    var galleryEl = root.querySelector('[data-gallery]');
    var moreWrap = root.querySelector('[data-more-wrap]');
    var moreBtn = root.querySelector('[data-more]');
    var prevBtn = root.querySelector('[data-gallery-prev]');
    var nextBtn = root.querySelector('[data-gallery-next]');

    var lightbox;
    function openLightbox(url) {
      if (!lightbox) {
        lightbox = document.createElement('div');
        lightbox.className = 'reviews__lightbox';
        lightbox.innerHTML = '<button class="reviews__lightbox-close" aria-label="Close">×</button><img alt="">';
        document.body.appendChild(lightbox);
        lightbox.addEventListener('click', function (e) { if (e.target === lightbox || e.target.classList.contains('reviews__lightbox-close')) lightbox.classList.remove('is-open'); });
      }
      lightbox.querySelector('img').src = url;
      lightbox.classList.add('is-open');
    }

    root.querySelectorAll('[data-lightbox]').forEach(function (el) {
      el.addEventListener('click', function () { openLightbox(el.getAttribute('data-lightbox')); });
    });

    // ----- Load more -----
    // Judge.me's metafield only holds its first page of reviews, so the first click finishes that
    // page (already in the HTML) and every click after it fetches the next page from Judge.me's
    // public widget endpoint. No token: that endpoint is the one their own widget calls.
    var listEl = root.querySelector('[data-list]');
    var jmShop = root.getAttribute('data-jm-shop');
    var jmProduct = root.getAttribute('data-jm-product');
    var jmStar = root.getAttribute('data-jm-star');
    var jmPages = parseInt(root.getAttribute('data-jm-pages'), 10) || 1;
    var jmPage = 1;
    var jmBusy = false;
    var jmFails = 0;
    // The page-1 rows come from a metafield Judge.me re-syncs on its own schedule, while the fetch
    // below is live. A review published in between shifts every later page down by one, which would
    // re-serve a row that is already on the page — so track what has been rendered.
    var jmSeen = {};
    if (listEl) {
      listEl.querySelectorAll('[data-rid]').forEach(function (el) { jmSeen[el.getAttribute('data-rid')] = true; });
    }

    function makeEl(tag, cls, text) {
      var node = document.createElement(tag);
      if (cls) node.className = cls;
      if (text != null) node.textContent = text;
      return node;
    }

    function starsHtml(rating) {
      var out = '';
      for (var i = 1; i <= 5; i++) {
        out += '<svg viewBox="0 0 24 24" fill="currentColor"' + (i > rating ? ' class="reviews__star--empty"' : '') +
          '><path d="' + jmStar + '"></path></svg>';
      }
      return out;
    }

    // Tags are stripped before the text ever reaches the DOM, and the textarea decodes entities
    // without executing anything.
    function plainText(html) {
      var box = document.createElement('textarea');
      box.innerHTML = String(html || '').replace(/<[^>]*>/g, '');
      return box.value.trim();
    }

    // ponytail: rendered in UTC so these line up with the Liquid rows above, which use the shop's
    // timezone. Judge.me stamps imported reviews at 16:00Z, so the two can only disagree for a
    // review created between 00:00 and 04:00 UTC.
    function fmtDate(iso) {
      var d = new Date(iso);
      if (isNaN(d.getTime())) return '';
      return d.toLocaleDateString('en-US', { timeZone: 'UTC', month: 'short', day: 'numeric', year: 'numeric' });
    }

    function buildRow(r) {
      var row = makeEl('div', 'reviews__row');

      var meta = makeEl('div', 'reviews__row-meta');
      var who = document.createElement('div');
      who.appendChild(makeEl('p', 'reviews__name ts-h-s', r.reviewer_name || ''));
      who.appendChild(makeEl('p', 'reviews__verified ar-testimonial-verified ts-sm-xs', 'Verified Client'));
      meta.appendChild(who);
      meta.appendChild(makeEl('p', 'reviews__date ts-sm-s', fmtDate(r.created_at)));
      row.appendChild(meta);

      var body = makeEl('div', 'reviews__row-body');
      var copyWrap = makeEl('div', 'reviews__row-copy-wrap');
      var stars = makeEl('div', 'reviews__row-stars');
      stars.setAttribute('aria-label', r.rating + ' stars');
      stars.innerHTML = starsHtml(r.rating);
      copyWrap.appendChild(stars);
      if (r.title) copyWrap.appendChild(makeEl('h4', 'reviews__row-title ts-h-m', r.title));
      copyWrap.appendChild(makeEl('p', 'reviews__row-copy ts-sub-xs', plainText(r.body_html || r.body)));
      body.appendChild(copyWrap);

      var pic = (r.pictures_urls || [])[0];
      if (pic && pic.original) {
        var photo = makeEl('div', 'reviews__row-photo');
        photo.setAttribute('data-lightbox', pic.original);
        var img = document.createElement('img');
        img.loading = 'lazy';
        img.src = pic.original;
        img.width = 256;
        img.height = 256;
        img.alt = (r.reviewer_name || '') + ' — client photo';
        photo.appendChild(img);
        photo.addEventListener('click', function () { openLightbox(pic.original); });
        body.appendChild(photo);
      }

      row.appendChild(body);
      return row;
    }

    function loadNextPage() {
      if (jmBusy || jmPage >= jmPages || !listEl || !jmShop || !jmProduct) return;
      jmBusy = true;
      moreBtn.setAttribute('aria-busy', 'true');
      var next = jmPage + 1;
      var url = 'https://judge.me/reviews/reviews_for_widget?url=' + encodeURIComponent(jmShop) +
        '&shop_domain=' + encodeURIComponent(jmShop) +
        '&platform=shopify&product_id=' + encodeURIComponent(jmProduct) +
        '&page=' + next;

      fetch(url)
        .then(function (res) { return res.ok ? res.json() : Promise.reject(res.status); })
        .then(function (data) {
          var batch = data.reviews || [];
          batch.forEach(function (r) {
            if (r.uuid && jmSeen[r.uuid]) return;
            if (r.uuid) jmSeen[r.uuid] = true;
            listEl.appendChild(buildRow(r));
          });
          jmPage = next;
          jmFails = 0;
          // total_pages comes from the same metafield as page 1, so it can lag the real count in
          // either direction — an empty page is the authoritative "that was the last one".
          if (jmPage >= jmPages || !batch.length) moreWrap.hidden = true;
        })
        .catch(function () {
          // One retry is worth offering; a second failure means the endpoint is gone or blocked,
          // and a button that never does anything is worse than no button.
          jmFails += 1;
          if (jmFails >= 2) moreWrap.hidden = true;
        })
        .then(function () {
          jmBusy = false;
          moreBtn.removeAttribute('aria-busy');
        });
    }

    if (moreBtn) moreBtn.addEventListener('click', function () {
      var collapsed = root.querySelectorAll('.reviews__row[hidden]');
      if (collapsed.length) {
        collapsed.forEach(function (r) { r.hidden = false; });
        if (jmPages <= 1) moreWrap.hidden = true;
        return;
      }
      loadNextPage();
    });

    function scrollGallery(dir) {
      if (!galleryEl) return;
      galleryEl.scrollBy({ left: dir * galleryEl.clientWidth * 0.8, behavior: 'smooth' });
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { scrollGallery(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollGallery(1); });

    // ----- Write-review modal: ARFORTI shell + embedded Judge.me form, else email-invite fallback -----
    var modal = document.querySelector('[data-review-modal]');
    var openBtn = root.querySelector('[data-review-open]');
    if (modal && openBtn) {
      var lastFocus = null;
      function openModal() {
        lastFocus = document.activeElement;
        modal.hidden = false;
        void modal.offsetWidth;
        modal.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        var content = modal.querySelector('.rev-modal__content');
        if (content) content.focus();
      }
      function closeModal() {
        modal.classList.remove('is-open');
        document.body.style.overflow = '';
        setTimeout(function () { modal.hidden = true; }, 500);
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }
      openBtn.addEventListener('click', openModal);
      modal.querySelectorAll('[data-review-close]').forEach(function (el) { el.addEventListener('click', closeModal); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["waitlist"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-waitlist]');
    if (!root) return;
    const grid = root.querySelector('[data-waitlist-grid]');
    const tabs = Array.from(root.querySelectorAll('.waitlist__tab'));
    if (!grid || tabs.length === 0) return;

    function matches(card, filter) {
      const status = card.dataset.availability;
      if (filter === 'all') return true;
      if (filter === 'ready') return status === 'ready';
      if (filter === 'awaiting') return status === 'production' || status === 'awaiting';
      return true;
    }

    function activeFilter() {
      const t = tabs.filter((x) => x.getAttribute('aria-pressed') === 'true')[0];
      return t ? (t.dataset.filter || 'all') : 'all';
    }
    function applyNow(filter) {
      Array.from(grid.querySelectorAll('.waitlist__card')).forEach((card) => { card.hidden = !matches(card, filter); });
    }
    function applyFilter(filter) {
      grid.style.opacity = '0';
      window.setTimeout(() => { applyNow(filter); grid.style.opacity = '1'; }, 180);
    }

    // 3.0: the Ready tab carries a live "(N)" count of securable cards; recount whenever the
    // data layer re-renders (Remove re-renders the grid, so removals recount automatically)
    const countEl = root.querySelector('[data-wl-ready-count]');
    function updateReadyCount() {
      if (!countEl) return;
      const n = grid.querySelectorAll('.waitlist__card[data-availability="ready"]').length;
      countEl.textContent = '(' + n + ')';
      const btn = countEl.closest('button');
      if (btn) btn.setAttribute('aria-label', btn.textContent.replace(/\s+/g, ' ').trim());
    }

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        tabs.forEach((t) => t.setAttribute('aria-pressed', 'false'));
        tab.setAttribute('aria-pressed', 'true');
        applyFilter(tab.dataset.filter || 'all');
      });
    });

    // re-apply the active filter after the data layer re-renders the grid
    grid.addEventListener('waitlist:rendered', function () { applyNow(activeFilter()); updateReadyCount(); });
    updateReadyCount();
  })();

  /* ---- Customer Account API: auth + load the customer's real waitlist ---- */
  (function () {
    var root = document.querySelector('[data-waitlist]');
    if (!root) return;
    var bar = root.querySelector('[data-waitlist-auth]');
    var grid = root.querySelector('[data-waitlist-grid]');
    var tabsEl = root.querySelector('[data-waitlist-tabs]');
    function showTabs(v) { if (tabsEl) tabsEl.hidden = !v; }
    var WL = window.__ARFORTI_WL__ || {};
    var SROOT = (WL.root || '').replace(/\/+$/, '');
    var CAARef = null, customerId = null;

    var READ = 'query GetWaitlist($ns:String!,$key:String!){ customer { id firstName lastName emailAddress { emailAddress } metafield(namespace:$ns,key:$key){ value } } }';
    var WRITE = 'mutation SetWaitlist($metafields:[MetafieldsSetInput!]!){ metafieldsSet(metafields:$metafields){ userErrors { field message } } }';

    function withCaa(fn) {
      if (window.ARFORTI_CAA) { fn(window.ARFORTI_CAA); }
      else { document.addEventListener('caa:ready', function () { fn(window.ARFORTI_CAA); }, { once: true }); }
    }
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function money(cents) {
      var hasCents = (cents % 100) !== 0;
      try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: WL.currency || 'USD', currencyDisplay: 'narrowSymbol', minimumFractionDigits: hasCents ? 2 : 0, maximumFractionDigits: hasCents ? 2 : 0 }).format(cents / 100); }
      catch (e) { return '$' + (cents / 100); }
    }
    function parseList(v) { if (!v) return []; try { var a = JSON.parse(v); return Array.isArray(a) ? a : []; } catch (e) { return []; } }

    // Render the card for ONE waitlisted variant (colour) of product p. Status is derived from the
    // variant's own availability; the restock date is the variant's custom.release_note metafield.
    function cardHtml(p, variantId) {
      var v = null;
      if (variantId != null && variantId !== '') v = (p.variants || []).filter(function (x) { return String(x.id) === String(variantId); })[0];
      if (!v) v = (p.variants && p.variants[0]); // fallback: legacy handle-only entry
      if (!v) return '';
      var ready = !!v.available;
      var entryKey = p.handle + ':' + v.id;
      var variantTitle = (v.title && v.title !== 'Default Title') ? v.title : '';
      var img0 = v.image || p.image || '';
      var price = (v.price != null) ? v.price : p.price;
      // 4.0 card copy: one flat info grid serves both widths (grid-template-areas reflow it) —
      // desktop = title / variant / price stacked; mobile = "title price" / "variant RM" rows.
      // Multi-option variant titles ("Black / Calfskin") break one option per line, and the
      // leather follows on its own line — it is a product metafield, not part of the colour,
      // so the colour name stays clean everywhere else on the site.
      var infoLines = variantTitle ? variantTitle.split(' / ').map(esc) : [];
      // Skipped when the leather is already an option value, or a two-option product would
      // print it twice — once from the variant title, once from the metafield.
      if (p.leather && infoLines.indexOf(esc(p.leather)) === -1) infoLines.push(esc(p.leather));
      var variantLines = infoLines.join('<br>');
      var productUrl = SROOT + '/products/' + encodeURIComponent(p.handle) + '?variant=' + encodeURIComponent(v.id);
      // "RM" = mobile-only remove on ready cards (desktop hides it; non-ready cards remove via the foot)
      var rm = ready ? '<button class="waitlist__rm ts-sm" type="button" data-wl-remove data-entry="' + esc(entryKey) + '" aria-label="Remove">RM</button>' : '';
      var head =
        '<a class="waitlist__media" href="' + esc(productUrl) + '">' + (img0 ? '<img class="waitlist__img" src="' + esc(img0) + '" alt="' + esc(p.title) + '" width="600" height="750" loading="lazy">' : '') + '</a>' +
        '<div class="waitlist__body"><div class="waitlist__head">' +
          '<h2 class="waitlist__product ts-h-l">' + esc(p.title) + '</h2>' +
          (variantLines ? '<p class="waitlist__variant ts-sm-xs">' + variantLines + '</p>' : '') +
          '<p class="waitlist__price ts-sm-l">' + money(price) + '</p>' + rm +
        '</div>';
      var statusRow, actions;
      if (ready) {
        statusRow = '<div class="waitlist__status"><span class="waitlist__dot waitlist__dot--pulse"></span><span class="waitlist__status-label ts-sm">Ready to Secure</span></div>';
        actions = '<div class="waitlist__actions">' +
          '<button class="waitlist__btn waitlist__btn--primary ts-sm" type="button" data-wl-secure data-variant-id="' + esc(v.id) + '">Secure Allocation</button>' +
          '<button class="waitlist__btn waitlist__btn--ghost ts-sm" type="button" data-wl-remove data-entry="' + esc(entryKey) + '">Remove</button></div>';
      } else {
        // status wording: desktop keeps "In Production"; mobile swaps to the expected date when the
        // variant has one (4.0 — the date moves up here, the foot's release line is desktop-only)
        var label = v.release_note
          ? '<span class="waitlist__status-label waitlist__status-label--desk ts-sm">In Production</span>' +
            '<span class="waitlist__status-label waitlist__status-label--mob ts-sm">Expected ' + esc(v.release_note) + '</span>'
          : '<span class="waitlist__status-label ts-sm">In Production</span>';
        statusRow = '<div class="waitlist__status"><span class="waitlist__dot"></span>' + label + '</div>';
        var release = v.release_note ? ('Expected release: ' + esc(v.release_note)) : 'We&rsquo;ll email you the moment it&rsquo;s released.';
        actions = '<div class="waitlist__foot"><p class="waitlist__release ts-sub-s">' + release + '</p>' +
          '<button class="waitlist__remove ts-sm" type="button" data-wl-remove data-entry="' + esc(entryKey) + '">Remove</button></div>';
      }
      return '<article class="waitlist__card" data-availability="' + (ready ? 'ready' : 'awaiting') + '">' + head + statusRow + actions + '</div></article>';
    }
    function emptyHtml() {
      var s = document.querySelector('[data-waitlist]');
      var url = (s && s.getAttribute('data-collection-url')) || '/collections/all';
      return '<div class="empty-state"><p class="empty-state__title ts-h-l">Your waitlist is empty</p><p class="empty-state__text ts-sm-m">Pieces you request while they are out of stock will appear here.</p><a class="empty-state__link ts-sm" href="' + url + '" data-empty-link>Return to Collection</a></div>';
    }

    // swap the grid content in with a soft fade (the grid carries `transition: opacity 0.24s`)
    // instead of a hard innerHTML pop. During an auth-load the whole page reveals together
    // (.waitlist--ready), so skip the per-grid fade then to avoid a double animation.
    function renderGrid(html) {
      var authing = root.classList.contains('waitlist--authing');
      if (!authing) grid.style.opacity = '0';
      grid.innerHTML = html;
      // renderGrid only runs in the signed-in data path (renderEntries), so show the tabs whenever
      // it renders — including the empty-list state. Signed-out uses showSignin() → showTabs(false).
      showTabs(true);
      grid.dispatchEvent(new Event('waitlist:rendered'));
      if (!authing) requestAnimationFrame(function () { grid.style.opacity = '1'; });
    }

    // account bar ("Signed in as … · Log out") — set from the SAME query as the waitlist (one round-trip).
    // The display name is cached (cleared with the cards cache) so a refresh paints the bar instantly
    // instead of popping it in when the query returns.
    // name === null → render the breathing skeleton in the name slot (query still in flight)
    function barHtml(name) {
      var slot = name
        ? '<span class="waitlist__authname">' + esc(name) + '</span>'
        : '<span class="waitlist__authname waitlist__authname--loading" aria-hidden="true"></span>';
      return 'Signed in as ' + slot + ' &middot; <button type="button" class="waitlist__authlink" data-caa-logout>Log out</button>';
    }
    // paint the frame immediately once we know the visitor is signed in; the name slot shows the
    // cached name if we have one, otherwise the skeleton until setBar() fills it
    function showBarFrame() {
      if (!bar || bar.innerHTML) return;
      var who = null; try { who = localStorage.getItem(WHO_KEY); } catch (e) {}
      bar.innerHTML = barHtml(who || null);
    }
    function setBar(c) {
      if (!bar) return;
      var full = c ? [c.firstName, c.lastName].filter(Boolean).join(' ') : '';
      var email = c && c.emailAddress && c.emailAddress.emailAddress;
      var name = full || email || 'your account';
      try { localStorage.setItem(WHO_KEY, name); } catch (e) {}
      var cur = bar.querySelector('.waitlist__authname');
      if (cur && !cur.classList.contains('waitlist__authname--loading') && cur.textContent === name) return; // same name already shown → don't re-fade
      bar.innerHTML = barHtml(name);
    }

    // localStorage cache → instant re-entry: paint the last-known cards, then refresh in the
    // background. (Cleared on logout / sign-in / fresh login so it never crosses users.)
    var CACHE_KEY = 'wl_cards_v1';
    var WHO_KEY = 'wl_who_v1'; // cached display name for the instant account bar
    var lastSig = null;
    var rawList = []; // raw ["handle:variantId", …] from the metafield, kept for Remove
    function parseEntries(arr) {
      return (arr || []).map(function (s) { var i = String(s).indexOf(':'); return i > -1 ? { handle: String(s).slice(0, i), vid: String(s).slice(i + 1) } : { handle: String(s), vid: null }; });
    }
    function readCache() { try { var o = JSON.parse(localStorage.getItem(CACHE_KEY)); return (o && o.entries) ? o : null; } catch (e) { return null; } }
    function clearCache() { lastSig = null; try { localStorage.removeItem(CACHE_KEY); localStorage.removeItem(WHO_KEY); } catch (e) {} }
    function writeCache(entries, byHandle) { try { localStorage.setItem(CACHE_KEY, JSON.stringify({ entries: entries, byHandle: byHandle })); } catch (e) {} }
    function renderEntries(entries, byHandle) {
      var html = entries.map(function (e) { var p = byHandle[e.handle]; return p ? cardHtml(p, e.vid) : ''; }).filter(Boolean).join('') || emptyHtml();
      if (html === lastSig) return;   // identical to what's already on screen → skip the redundant re-render/fade
      lastSig = html;
      renderGrid(html);
    }

    function load() {
      if (!CAARef || !grid) return Promise.resolve();
      return CAARef.query(READ, { ns: WL.ns || 'custom', key: WL.key || 'waitlist' }).then(function (res) {
        if (!res || res.errors || !(res.data && res.data.customer)) { showSignin(); return; } // no/expired session → show the prompt
        var c = res.data.customer;
        setBar(c);
        customerId = c.id;
        rawList = parseList(c.metafield && c.metafield.value);
        var entries = parseEntries(rawList);
        if (!entries.length) { writeCache([], {}); renderEntries([], {}); return; }
        var uniq = []; entries.forEach(function (e) { if (uniq.indexOf(e.handle) < 0) uniq.push(e.handle); });
        return Promise.all(uniq.map(function (h) {
          // ?view=wl renders templates/product.wl.liquid → per-variant JSON (availability + restock date)
          return fetch(SROOT + '/products/' + encodeURIComponent(h) + '?view=wl')
            .then(function (r) { return r.ok ? r.text() : ''; })
            .then(function (t) { try { return JSON.parse(t); } catch (e) { return null; } })
            .catch(function () { return null; });
        })).then(function (results) {
          var byHandle = {};
          uniq.forEach(function (h, i) { if (results[i]) byHandle[h] = results[i]; });
          writeCache(entries, byHandle);
          renderEntries(entries, byHandle);
        });
      });
    }

    // Buttons waiting for the cart drawer's add result, in FIFO order (adds are serialized).
    var pendingBtns = [];
    function secure(variantId, btn) {
      if (!variantId) return;
      if (btn) { btn.classList.add('is-securing'); btn.disabled = true; btn.setAttribute('aria-busy', 'true'); } // shows "SECURING…" via CSS
      pendingBtns.push(btn || null);
      // The cart drawer does the add + opens itself, then reports back via 'arforti:cart-added'.
      document.dispatchEvent(new CustomEvent('arforti:cart-add', { detail: { id: variantId } }));
    }
    // When the add finishes: success → brief "ALLOCATED", failure → Shopify's message, then reset.
    document.addEventListener('arforti:cart-added', function (e) {
      var btn = pendingBtns.shift();
      if (!btn) return;
      btn.classList.remove('is-securing');
      if (e.detail && e.detail.ok === false) {
        btn.disabled = false; btn.removeAttribute('aria-busy');
        if (!btn.getAttribute('data-label')) btn.setAttribute('data-label', btn.textContent);
        btn.classList.add('is-note');
        btn.textContent = e.detail.message || 'Unavailable';
        setTimeout(function () {
          if (!btn.isConnected) return;
          btn.classList.remove('is-note');
          btn.textContent = btn.getAttribute('data-label');
        }, 2600);
      } else {
        btn.classList.add('is-allocated'); // shows "ALLOCATED" via CSS
        setTimeout(function () {
          if (!btn.isConnected) return;
          btn.classList.remove('is-allocated');
          btn.disabled = false; btn.removeAttribute('aria-busy');
        }, 1400);
      }
    });
    // Confirm-first removal (same discipline as the cart drawer): the card stays put and shows a
    // pending state while the metafield write is in flight, and only leaves AFTER the server
    // confirms. On failure the card stays and shows an error — a buyer on a bad connection never
    // sees a delete that didn't actually happen. NOT optimistic (no delete-then-maybe-reappear).
    var removing = {}; // guard against double-clicks per entry
    function removeEntry(key, btn) {
      if (!btn || removing[key]) return;
      var card = btn.closest('.waitlist__card');
      if (!card) return;
      removing[key] = true;
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      card.classList.add('is-removing'); // dims + locks the card (matches the cart drawer's is-updating)
      var note = card.querySelector('.waitlist__remove-error'); if (note) note.remove();
      // click feedback = the card dims (like the cart) + the button's underline-cut (320ms). The card
      // only leaves after the server confirms, then fades out.
      var underlined = btn.classList.contains('waitlist__rm') || btn.classList.contains('waitlist__remove');
      if (underlined && !reduced) { btn.classList.remove('is-cutting'); void btn.offsetWidth; btn.classList.add('is-cutting'); }

      var next = rawList.filter(function (x) { return x !== key; });
      CAARef.query(WRITE, { metafields: [{ ownerId: customerId, namespace: WL.ns || 'custom', key: WL.key || 'waitlist', type: 'json', value: JSON.stringify(next) }] })
        .then(function (res) {
          var ue = res && res.data && res.data.metafieldsSet && res.data.metafieldsSet.userErrors;
          if (!res || res.errors || (ue && ue.length)) throw new Error('write rejected');
          rawList = next;
          // keep the instant-paint cache in step with the server: otherwise a refresh repaints the
          // just-removed card from the stale cache, then load() drops it again → the "pops back then
          // disappears" flash. Reuse the cached product data (byHandle) for the remaining entries.
          try { var _c = readCache(); writeCache(parseEntries(rawList), (_c && _c.byHandle) || {}); } catch (e) {}
          delete removing[key];
          if (reduced) { card.remove(); resyncAfterRemove(); return; }
          card.style.transition = 'opacity 0.4s ease'; card.style.opacity = '0'; // confirmed → fade the card out
          setTimeout(function () { card.remove(); resyncAfterRemove(); }, 400);
        })
        .catch(function () {
          delete removing[key];
          card.classList.remove('is-removing');
          if (underlined) btn.classList.remove('is-cutting'); // restore the underline — nothing was removed
          var e = document.createElement('p');
          e.className = 'waitlist__remove-error ts-sm-xs';
          e.textContent = 'Couldn’t remove — please try again.';
          card.querySelector('.waitlist__body').appendChild(e);
          setTimeout(function () { if (e.parentNode) e.remove(); }, 4000);
        });
    }
    // after a confirmed removal: if the grid is now empty, show the empty state; otherwise just
    // recount. No full re-read — the write already succeeded, so the DOM is the truth.
    function resyncAfterRemove() {
      lastSig = null;
      if (!grid.querySelector('.waitlist__card')) { renderGrid(emptyHtml()); }
      else { grid.dispatchEvent(new Event('waitlist:rendered')); }
    }

    if (grid) grid.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-wl-remove]'); if (rm) { e.preventDefault(); removeEntry(rm.dataset.entry, rm); return; }
      var sec = e.target.closest('[data-wl-secure]'); if (sec) { e.preventDefault(); secure(sec.dataset.variantId, sec); }
    });
    // shared "line-cut": the underline retracts left→right, THEN the action runs (Log out + Contact)
    function lineCut(el, cls, after) {
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) { after(); return; }
      el.classList.remove(cls);
      void el.offsetWidth; /* reflow so the cut animation restarts */
      el.classList.add(cls);
      setTimeout(after, 320);
    }
    document.addEventListener('click', function (e) {
      var loginBtn = e.target.closest('[data-caa-login]');
      if (loginBtn) { e.preventDefault(); loginBtn.classList.add('is-pulse'); withCaa(function (C) { C.login(); }); return; }
      var inq = e.target.closest('[data-wl-inquiry]');
      if (inq) { e.preventDefault(); var href = inq.getAttribute('href'); lineCut(inq, 'waitlist__inquiry-link--cutting', function () { if (href) window.location.href = href; }); return; }
      var lo = e.target.closest('[data-caa-logout]');
      if (lo) { e.preventDefault(); lineCut(lo, 'waitlist__authlink--cutting', function () { clearCache(); withCaa(function (C) { C.logout(); }); }); }
    });

    var returningFromAuth = /[?&]code=/.test(location.search);
    var signinHTML = grid ? grid.innerHTML : '';   // the server-rendered sign-in screen, to restore on no/expired session
    var loginPulseBtn = root.querySelector('[data-caa-login]');
    var signinEl = root.querySelector('[data-waitlist-signin]');

    // Re-show the "Private Access" sign-in prompt (no session / it expired).
    function showSignin() {
      clearCache(); // no valid session → drop any cached cards so they can't show next time
      root.classList.remove('waitlist--authing', 'waitlist--ready'); // ensure the page is visible if we fall back to the prompt
      if (grid) { grid.style.opacity = ''; grid.innerHTML = signinHTML; }
      loginPulseBtn = root.querySelector('[data-caa-login]');
      if (bar) bar.innerHTML = '';
      showTabs(false);
    }

    function reveal() {
      root.classList.remove('waitlist--authing');
      root.classList.add('waitlist--ready');
      setTimeout(function () { root.classList.remove('waitlist--ready'); }, 450); // clear after the fade so later re-renders fade normally
    }
    // Load the waitlist + reveal (title + cards together, fade-up). If cached cards exist, paint them
    // INSTANTLY and reveal now, then refresh in the background → re-entry feels immediate.
    function revealLoad() {
      root.classList.add('waitlist--authing');
      root.classList.remove('waitlist--ready');
      showBarFrame(); // frame + (cached name | skeleton) up now; the query re-sets the name silently
      var cached = readCache();
      if (cached && cached.entries && cached.entries.length) {
        renderEntries(cached.entries, cached.byHandle); // instant paint from cache (authing on → hidden)
        reveal();
        return load();       // refresh in the background (renderEntries skips the re-render if unchanged)
      }
      return load().then(reveal);
    }

    withCaa(function (CAA) {
      CAARef = CAA;
      if (returningFromAuth) {
        // Popup-blocked fallback: a full-page redirect login came back — pulse the button as the loader
        // and kill the fade-up so it doesn't replay/flash on the instant SSO return.
        if (loginPulseBtn) loginPulseBtn.classList.add('is-pulse');
        if (signinEl) signinEl.style.animation = 'none';
        showTabs(false);
      } else if (CAA.isLoggedIn()) {
        // Remembered session → skip the "Private Access" prompt; hide the page now, reveal it all
        // together once the waitlist has loaded (so the title doesn't show before the cards).
        root.classList.add('waitlist--authing');
        showTabs(false);
      }
      CAA.handleCallback().then(function (justLoggedIn) {
        if (CAA.isLoggedIn()) {
          if (justLoggedIn && loginPulseBtn) {
            clearCache(); // fresh login → don't paint a previous session's cached cards
            loginPulseBtn.classList.remove('is-pulse');
            loginPulseBtn.classList.add('is-granted'); // success flash (2.0) → then reveal
            setTimeout(revealLoad, 800);
          } else {
            revealLoad(); // remembered → load + reveal together
          }
        } else {
          if (loginPulseBtn) loginPulseBtn.classList.remove('is-pulse');
          showSignin();   // no/expired session → show the sign-in prompt
          CAA.discover(); // warm discovery so the Sign in click is snappy
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
